<template>
  <div>
    <section class="hero">
      <div class="hero-body">
        <div class="columns">
          <div class="column is-3">
            <p class="title">{{ i18n.guests[iso] }}</p>
          </div>
          <div class="column is-3" v-if="$checkPermission('cap-guests-create')">
            <b-button
              icon-left="user-plus"
              icon-pack="fas"
              type="is-success"
              expanded
              @click="openModalCrear"
            >{{ i18n.createGuest[iso] }}</b-button>
          </div>
          <div class="column is-3" v-if="$checkPermission('cap-create-meeting') || $checkPermission('cap-delete-meeting')">
            <b-dropdown aria-role="list" expanded>
              <template #trigger>
                <b-button
                  icon-left="chevron-down"
                  icon-pack="fas"
                  type="is-info is-light"
                  expanded
                >{{ i18n.actions[iso] }}</b-button>
              </template>

              <b-dropdown-item aria-role="listitem" @click="openModalCrearReunion" v-if="$checkPermission('cap-create-meeting')">
                <b-icon pack="fas" icon="video" size="is-small" style="margin-right: 0.5em;"></b-icon>
                {{ i18n.createMeeting[iso] }}
              </b-dropdown-item>

              <b-dropdown-item aria-role="listitem" @click="openModalEliminarReunion" v-if="$checkPermission('cap-delete-meeting')">
                <b-icon pack="fas" icon="trash" size="is-small" style="margin-right: 0.5em;"></b-icon>
                {{ i18n.deleteMeeting[iso] }}
              </b-dropdown-item>
            </b-dropdown>
          </div>
        </div>
      </div>
    </section>
    <div class="columns is-multiline"></div>
    <b-tabs v-model="tabFilters" position="is-centered">
      <b-tab-item>
        <template #header>
          <b-icon icon="filter" pack="fas" type="is-info"></b-icon>
          <b>{{ i18n.advancedSearch[iso] }}</b>
        </template>
        <div class="columns is-multiline filter-compact">
          <!-- Primera fila: 4 campos de búsqueda justificados -->
          <div class="column is-3">
            <b-field :label="i18n.guestId[iso]" label-position="on-border">
              <b-input
                v-model="filters.IdInvitado"
                type="text"
                icon-right="times"
                icon-right-clickable
                expanded
              >
              </b-input>
            </b-field>
          </div>
          <div class="column is-3">
            <b-field :label="i18n.name[iso]" label-position="on-border">
              <b-input
                v-model="filters.Nombre"
                type="text"
                icon-right="times"
                icon-right-clickable
                expanded
              >
              </b-input>
            </b-field>
          </div>
          <div class="column is-3">
            <b-field :label="i18n.lastname[iso]" label-position="on-border">
              <b-input
                v-model="filters.Apellido"
                type="text"
                icon-right="times"
                icon-right-clickable
                expanded
              >
              </b-input>
            </b-field>
          </div>
          <div class="column is-3">
            <b-field :label="i18n.email[iso]" label-position="on-border">
              <b-input
                v-model="filters.Email"
                type="text"
                icon-right="times"
                icon-right-clickable
                expanded
              >
              </b-input>
            </b-field>
          </div>

          <!-- Segunda fila: Stage, Meeting Date, Origen y botones -->
          <div class="column is-3">
            <b-field :label="i18n.stage[iso]" label-position="on-border">
              <b-select
                v-model="filters.EstadoHubSpot"
                :placeholder="i18n.selectStage[iso]"
                expanded
                @input="onFilterChange"
              >
                <option :value="null">{{ i18n.all[iso] }}</option>
                <option
                  v-for="stage in hubspotStages"
                  :key="stage"
                  :value="stage"
                >
                  {{ getStageTranslation(stage, iso) }}
                </option>
              </b-select>
            </b-field>
          </div>
          <div class="column is-3">
            <b-field :label="i18n.meetingDateTime[iso]" label-position="on-border">
              <b-datepicker
                v-model="filters.MeetingDate"
                range
                icon="calendar"
                icon-pack="fas"
                append-to-body
                :placeholder="i18n.selectDateRange[iso] || i18n.meetingDateTime[iso]"
                expanded
              ></b-datepicker>
            </b-field>
          </div>
          <div class="column is-2">
            <b-field :label="ssp.origin" label-position="on-border">
              <b-select v-model="filters.Origen" expanded @input="onFilterChange">
                <option :value="null">{{ ssp.allOrigins }}</option>
                <option value="in house">{{ ssp.inHouse }}</option>
                <option value="Marketing SSP">{{ ssp.marketingSsp }}</option>
              </b-select>
            </b-field>
          </div>
          <div class="column is-2">
            <b-button
              icon-left="search"
              icon-pack="fas"
              type="is-info"
              @click="listProspectos()"
              expanded
            >{{ i18n.search[iso] }}</b-button>
          </div>
          <div class="column is-2">
            <b-button
              icon-left="eraser"
              icon-pack="fas"
              type="is-danger is-light"
              @click="clearFilters"
              expanded
            >{{ i18n.resetSearch[iso] }}</b-button>
          </div>
        </div>
      </b-tab-item>
    </b-tabs>
    <b-table
      :data="prospectos"
      :paginated="isPaginated"
      backend-pagination
      :total="total"
      :per-page="perPage"
      @page-change="onPageChange"
      :current-page.sync="currentPage"
      :pagination-simple="isPaginationSimple"
      :pagination-position="paginationPosition"
      :default-sort-direction="defaultSortDirection"
      :pagination-rounded="isPaginationRounded"
      :sort-icon="sortIcon"
      :sort-icon-size="sortIconSize"
      aria-next-label="Next page"
      aria-previous-label="Previous page"
      aria-page-label="Page"
      aria-current-label="Current page"
      :bordered="isBordered"
      :striped="true"
      :narrowed="isNarrowed"
      :hoverable="true"
      :loading="loadingTableList"
      :focusable="isFocusable"
      :mobile-cards="hasMobileCards"
      :detailed="false"
    >
      <b-table-column
        field="IdInvitado"
        :label="i18n.guestId[iso]"
        sortable
        centered
        v-slot="props"
      >
        {{ props.row.IdInvitado || "" }}
      </b-table-column>
      <b-table-column
        field="Origen"
        :label="ssp.origin"
        centered
        v-slot="props"
      >
        <!-- Ícono con el nombre completo en el tooltip, para no ensanchar la tabla -->
        <b-tooltip :label="isSsp(props.row) ? ssp.marketingSsp : ssp.inHouse" type="is-dark">
          <b-icon
            pack="fas"
            :icon="isSsp(props.row) ? 'bullhorn' : 'home'"
            :type="isSsp(props.row) ? 'is-link' : 'is-grey'"
            size="is-small"
          ></b-icon>
        </b-tooltip>
        <b-tooltip
          v-if="tieneRevision(props.row)"
          :label="revisionTooltip(props.row)"
          type="is-warning"
          multilined
        >
          <b-icon pack="fas" icon="exclamation-triangle" type="is-warning" size="is-small" style="margin-left: 0.35em;"></b-icon>
        </b-tooltip>
      </b-table-column>
      <b-table-column
        field="Nombre"
        :label="i18n.name[iso]"
        sortable
        centered
        v-slot="props"
      >
        {{ props.row.Nombre || "" }}
      </b-table-column>

      <b-table-column
        field="Apellido"
        :label="i18n.lastname[iso]"
        sortable
        centered
        v-slot="props"
      >
        {{ props.row.Apellido || "" }}
      </b-table-column>

      <b-table-column
        field="Email"
        :label="i18n.email[iso]"
        sortable
        centered
        v-slot="props"
      >
        {{ props.row.Email || "" }}
      </b-table-column>

      <b-table-column
        field="Telefono"
        :label="i18n.phone[iso]"
        sortable
        centered
        v-slot="props"
      >
        {{ props.row.Telefono || "" }}
      </b-table-column>

      <b-table-column
        field="Vendedor"
        :label="i18n.vendor[iso]"
        sortable
        :custom-sort="sortByVendor"
        centered
        v-slot="props"
      >
        <span v-if="getVendorName(props.row)">{{ getVendorName(props.row) }}</span>
        <span v-else style="color: #999;">N/A</span>
      </b-table-column>

      <b-table-column field="EstadoHubSpot" :label="i18n.appointmentStatusColumn[iso]" sortable centered v-slot="props">
        <!-- El estado de la cita con los nombres de GHL; la etapa de HubSpot queda en el tooltip -->
        <b-tooltip
          v-if="estadoCitaFila(props.row)"
          :label="etapaHubspotTooltip(props.row)"
          :active="!!props.row.EstadoHubSpot"
          type="is-dark"
          multilined
        >
          <b-tag :type="estadoCitaFila(props.row).tipo">{{ estadoCitaFila(props.row).texto }}</b-tag>
        </b-tooltip>
        <b-tooltip v-else-if="props.row.EstadoHubSpot" :label="etapaHubspotTooltip(props.row)" type="is-dark" multilined>
          <span style="color: #999;">—</span>
        </b-tooltip>
        <span v-else style="color: #999;">N/A</span>
      </b-table-column>

      <b-table-column field="Manifiesto.Rating" :label="i18n.rating[iso]" sortable centered v-slot="props">
        <template v-if="ratingFila(props.row)">
          <b-tooltip :label="detalleRating(props.row)" type="is-dark" multilined>
            <b-tag :type="ratingFila(props.row).tipo">{{ ratingFila(props.row).texto }}</b-tag>
          </b-tooltip>
          <div v-if="faltantesManifiesto(props.row).length" class="mt-1">
            <b-tooltip
              :label="`${i18n.manifestMissing[iso]}: ${faltantesManifiesto(props.row).join(', ')}`"
              type="is-dark"
              multilined
            >
              <b-tag type="is-warning is-light" size="is-small">{{ i18n.manifestIncomplete[iso] }}</b-tag>
            </b-tooltip>
          </div>
        </template>
        <b-tooltip v-else-if="manifiestoPendiente(props.row)" :label="i18n.manifestPendingHint[iso]" type="is-dark" multilined>
          <b-tag type="is-warning" icon="clock" icon-pack="fas">{{ i18n.manifestPending[iso] }}</b-tag>
        </b-tooltip>
        <span v-else style="color: #999;">—</span>
      </b-table-column>

      <b-table-column
        field="MeetingDate"
        :label="i18n.meetingDateTime[iso]"
        sortable
        :custom-sort="sortByMeetingDateTime"
        centered
        v-slot="props"
      >
        <span v-if="props.row.MeetingDate">
          {{ getMeetingDateTime(props.row) }}
          <b-tag
            v-if="!props.row.MeetingId && tieneMarca(props.row, 'horario_no_encontrado')"
            type="is-warning is-light"
            style="margin-left: 0.35em;"
          >{{ ssp.reviewShort.horario_no_encontrado }}</b-tag>
        </span>
        <b-tag v-else-if="isSsp(props.row) && citaCancelada(props.row)" type="is-danger is-light">{{
          citaEstadoLabel(props.row)
        }}</b-tag>
        <span v-else style="color: #999;">N/A</span>
      </b-table-column>

      <!-- Ver detalle queda a la vista; el resto va en un menú con nombre para
           que la fila no crezca hacia abajo cuando la columna se angosta -->
      <b-table-column :label="i18n.actions[iso]" v-slot="props" centered cell-class="guest-actions-cell">
        <div class="guest-actions">
          <b-tooltip :label="i18n.viewDetail[iso]" type="is-warning is-light" v-if="$checkPermission('cap-guests-view-coupons')">
            <b-button
              icon-left="eye"
              icon-pack="fas"
              size="is-small"
              class="is-orange-light"
              @click="openModalDetalle(props.row)"
            ></b-button>
          </b-tooltip>

          <b-dropdown
            v-if="tieneMenuAcciones(props.row)"
            aria-role="list"
            position="is-bottom-left"
            append-to-body
          >
            <template #trigger>
              <b-button icon-left="ellipsis-v" icon-pack="fas" size="is-small" type="is-light"></b-button>
            </template>

            <!-- Los leads SSP se editan desde GoHighLevel: su siguiente evento actualiza el registro -->
            <b-dropdown-item
              v-if="$checkPermission('cap-guests-edit')"
              aria-role="listitem"
              :disabled="isSsp(props.row)"
              @click="openModalEditar(props.row)"
            >
              <b-icon pack="fas" icon="pen" size="is-small" type="is-warning"></b-icon>
              {{ i18n.edit[iso] }}
              <p v-if="isSsp(props.row)" class="guest-actions-hint">{{ ssp.editInGhl }}</p>
            </b-dropdown-item>
            <b-dropdown-item
              v-if="$checkPermission('cap-guests-manifest')"
              aria-role="listitem"
              @click="openModalManifiesto(props.row)"
            >
              <b-icon pack="fas" icon="clipboard-list" size="is-small" type="is-link"></b-icon>
              {{ i18n.manifest[iso] }}
            </b-dropdown-item>
            <b-dropdown-item
              v-if="$checkPermission('cap-guests-register-code')"
              aria-role="listitem"
              :disabled="!props.row.MeetingId"
              @click="openModalRegistrarCodigo(props.row)"
            >
              <b-icon pack="fas" icon="ticket-alt" size="is-small" type="is-info"></b-icon>
              {{ i18n.registerCode[iso] }}
              <p v-if="!props.row.MeetingId" class="guest-actions-hint">{{ i18n.noMeetingAssigned[iso] }}</p>
            </b-dropdown-item>
            <b-dropdown-item
              v-if="props.row.ContractId && $checkPermission('cap-guests-complete-registration')"
              aria-role="listitem"
              @click="goToProfile(props.row)"
            >
              <b-icon pack="fas" icon="user" size="is-small" type="is-primary"></b-icon>
              {{ i18n.viewProfile[iso] }}
            </b-dropdown-item>
            <b-dropdown-item
              v-if="!props.row.ContractId && $checkPermission('cap-guests-complete-registration')"
              aria-role="listitem"
              @click="registerMember(props.row)"
            >
              <b-icon pack="fas" icon="user-plus" size="is-small" type="is-success"></b-icon>
              {{ i18n.completeRegistration[iso] }}
            </b-dropdown-item>
            <b-dropdown-item
              v-if="puedeGenerarLinkPago(props.row)"
              aria-role="listitem"
              @click="openModalPaymentLink(props.row)"
            >
              <b-icon pack="fas" icon="link" size="is-small" type="is-info"></b-icon>
              {{ i18n.paymentLink[iso] }}
            </b-dropdown-item>
          </b-dropdown>
        </div>
      </b-table-column>

      <template #footer>
        <div class="columns">
          <div class="column is-11"></div>

          <div class="column is-1">
            <b-field :label="i18n.quantity[iso]">
              <b-select v-model="perPage" @input="savePerPage" expanded>
                <option :value="5">5</option>
                <option :value="10">10</option>
                <option :value="20">20</option>
                <option :value="50">50</option>
              </b-select>
            </b-field>
          </div>
        </div>
      </template>
    </b-table>

    <!-- Modal Create/Edit Guest -->
    <b-modal v-model="ModalProspecto" :width="700" :can-cancel="['x']">
      <div class="card">
        <header class="card-header">
          <p class="card-header-title">
            {{ editingProspecto ? i18n.editGuest[iso] : i18n.createGuest[iso] }}
          </p>
          <button
            class="card-header-icon"
            aria-label="more options"
            @click="ModalProspecto = false"
          >
            <b-icon pack="fas" icon="times" type="is-danger"></b-icon>
          </button>
        </header>
        <div class="card-content">
          <fieldset :disabled="isProspectoPaid">
          <div class="columns is-multiline">
            <div class="column is-6">
              <b-field :label="i18n.name[iso]" label-position="on-border">
                <b-input
                  v-model="prospecto.Nombre"
                  type="text"
                  placeholder="Joe"
                  icon-right="times"
                  icon-pack="fas"
                  icon-right-clickable
                  @icon-right-click="prospecto.Nombre = null"
                  expanded
                  :maxlength="30"
                  :has-counter="true"
                >
                </b-input>
              </b-field>
            </div>
            <div class="column is-6">
              <b-field :label="i18n.lastname[iso]" label-position="on-border">
                <b-input
                  v-model="prospecto.Apellido"
                  type="text"
                  placeholder="Dza"
                  icon-right="times"
                  icon-pack="fas"
                  icon-right-clickable
                  @icon-right-click="prospecto.Apellido = null"
                  expanded
                  :maxlength="30"
                  :has-counter="true"
                >
                </b-input>
              </b-field>
            </div>
            <div class="column is-6">
              <b-field :label="i18n.email[iso]" label-position="on-border">
                <b-input
                  v-model="prospecto.Email"
                  type="text"
                  placeholder="joedza@mail.com"
                  icon-right="times"
                  icon-pack="fas"
                  icon-right-clickable
                  @icon-right-click="prospecto.Email = null"
                  expanded
                  :maxlength="100"
                  :has-counter="true"
                >
                </b-input>
              </b-field>
            </div>
            <div class="column is-2">
              <b-field :label="i18n.areaCode[iso]" label-position="on-border">
                <b-select
                  v-model="prospecto.Lada"
                  expanded
                  :loading="loadingCatPaises"
                >
                  <option
                    v-for="pais in uniqueLadas"
                    :key="`lada-${pais.Id}`"
                    :value="pais.Lada"
                  >
                    +{{ pais.Lada }}
                  </option>
                </b-select>
              </b-field>
            </div>
            <div class="column is-4">
              <b-field :label="i18n.phone[iso]" label-position="on-border">
                <b-input
                  v-model="prospecto.Telefono"
                  type="text"
                  placeholder="6102448983"
                  icon-right="times"
                  icon-pack="fas"
                  icon-right-clickable
                  @icon-right-click="prospecto.Telefono = null"
                  @keypress.native="validatePhoneKeypress"
                  @input="validatePhoneInput"
                  expanded
                  :maxlength="30"
                  :has-counter="true"
                >
                </b-input>
              </b-field>
            </div>
            <div class="column is-6">
              <b-field :label="i18n.nationality[iso]" label-position="on-border">
                <b-select
                  v-model="prospecto.Nacionalidad"
                  expanded
                  :loading="loadingCatPaises"
                >
                  <option
                    v-for="pais in sortedPaises"
                    :key="`nac-${pais.Id}`"
                    :value="pais.Id"
                  >
                    {{ iso === 'es' ? pais.Nacionalidad : (pais.NacionalidadEn || pais.Nacionalidad) }}
                  </option>
                </b-select>
              </b-field>
            </div>
            <div class="column is-6">
              <b-field :label="i18n.language[iso]" label-position="on-border">
                <b-select v-model="prospecto.Idioma" expanded>
                  <option :value="'EN'">
                    {{ i18n.english[iso] }}
                  </option>
                  <option :value="'SP'">
                    {{ i18n.spanish[iso] }}
                  </option>
                </b-select>
              </b-field>
            </div>
            <div class="column is-6">
              <b-field :label="i18n.guestMeetingDate[iso]" label-position="on-border">
                <b-datepicker
                  v-model="prospecto.MeetingDate"
                  icon="calendar"
                  icon-pack="fas"
                  append-to-body
                  :min-date="getTodayStart()"
                  :events="meetingDateEvents"
                  indicators="bars"
                  expanded
                ></b-datepicker>
              </b-field>
              <p class="is-size-7 mt-1" style="color: #7a7a7a; font-style: italic;">
                {{ i18n.timezoneNotice[iso] }}
              </p>
              <p class="is-size-7 mt-2">
                <span class="has-text-success">
                  <b-icon pack="fas" icon="square" size="is-small"></b-icon> <span style="color: black">0-{{ dayWarningThreshold - 1 }} {{ i18n.seatsLabel[iso] }}</span>
                </span>
                <span class="has-text-warning ml-3">
                  <b-icon pack="fas" icon="square" size="is-small"></b-icon> <span style="color: black">{{ dayWarningThreshold }}-{{ dayCapacity - 1 }} {{ i18n.seatsLabel[iso] }}</span>
                </span>
                <span class="has-text-danger ml-3">
                  <b-icon pack="fas" icon="square" size="is-small"></b-icon> <span style="color: black">{{ dayCapacity }}+ {{ i18n.seatsLabel[iso] }}</span>
                </span>
              </p>
            </div>
            <div class="column is-6">
              <b-field :label="i18n.meetingTime[iso]" label-position="on-border">
                <b-select
                  v-model="prospecto.MeetingId"
                  expanded
                  :loading="loadingReuniones"
                  :disabled="!prospecto.MeetingDate"
                >
                  <option :value="null">
                    {{ prospecto.MeetingDate ? i18n.selectMeeting[iso] : 'Selecciona fecha primero' }}
                  </option>
                  <option
                    v-for="r in hourOptions"
                    :key="`meeting-${r._id}`"
                    :value="r._id"
                    :disabled="r.isDisabled"
                  >
                    {{ formatHora(r.Hora) }} ({{ r.availableInHour }} {{ i18n.availableSeats[iso] }}){{ r.isDisabled ? ' - ' + i18n.full[iso] : '' }}
                  </option>
                </b-select>
              </b-field>
            </div>
            <div class="column is-12">
              <b-field :label="i18n.notes[iso]" label-position="on-border">
                <b-input
                  v-model="prospecto.Transaccion"
                  type="text"
                  :placeholder="i18n.notesPlaceholder[iso]"
                  icon-right="times"
                  icon-pack="fas"
                  icon-right-clickable
                  @icon-right-click="prospecto.Transaccion = null"
                  expanded
                  :maxlength="50"
                  :has-counter="true"
                >
                </b-input>
              </b-field>
            </div>
            <div class="column is-12" v-if="programDistributors.length">
              <b-field :label="i18n.program[iso]" label-position="on-border">
                <b-select
                  v-model="prospecto.DistributorId"
                  expanded
                  :disabled="programDistributors.length === 1"
                  :placeholder="i18n.selectProgram[iso]"
                  @input="onDistributorChange"
                >
                  <option
                    v-for="d in programDistributors"
                    :value="d.Id"
                    :key="d.Id"
                  >
                    {{ d.Nombre }}{{ d.ClubNombre ? ` (${d.ClubNombre})` : "" }}
                  </option>
                </b-select>
              </b-field>
            </div>
            <div class="column is-12" v-if="availableVendors.length || isCurrentUserVendor">
              <b-field :label="i18n.vendor[iso]" label-position="on-border">
                <b-select
                  v-model="prospecto.Vendedor"
                  expanded
                  :loading="loadingVendedores"
                  :disabled="isCurrentUserVendor"
                  :placeholder="i18n.vendor[iso]"
                >
                  <option
                    v-for="u in displayVendors"
                    :value="u._id"
                    :key="u._id"
                  >
                    {{ u.Nombre }}
                  </option>
                </b-select>
              </b-field>
            </div>

            <div class="column is-12 has-text-centered" v-if="errorProspecto">
              <span style="color: #f14668; font-weight: bold">{{
                errorProspecto
              }}</span>
            </div>
          </div>
          </fieldset>
        </div>
        <footer class="card-footer" v-if="!isProspectoPaid">
          <a class="card-footer-item" @click="saveProspecto">
            <span style="color: #48c78e; font-weight: bold; font-size: 130%">{{
              i18n.save[iso]
            }}</span>
            <b-icon
              pack="fas"
              :icon="loadingProspecto ? 'sync-alt' : 'save'"
              type="is-success"
              :custom-class="loadingProspecto ? 'fa-spin' : ''"
            ></b-icon>
          </a>
        </footer>
      </div>
    </b-modal>

    <!-- Modal Registrar Código -->
    <b-modal v-model="ModalRegistrarCodigo" :width="400" :can-cancel="['x']">
      <div class="card">
        <header class="card-header">
          <p class="card-header-title">{{ i18n.registerCode[iso] }}</p>
          <button
            class="card-header-icon"
            aria-label="more options"
            @click="ModalRegistrarCodigo = false"
          >
            <b-icon pack="fas" icon="times" type="is-danger"></b-icon>
          </button>
        </header>
        <div class="card-content">
          <div class="columns is-multiline">
            <div class="column is-12" v-if="programDistributors.length">
              <b-field :label="i18n.program[iso]" label-position="on-border">
                <b-select
                  v-model="registrarCodigo.distributorId"
                  expanded
                  placeholder="Todos"
                  @input="fetchCuponesList"
                >
                  <option :value="null">{{ i18n.all[iso] }}</option>
                  <option
                    v-for="d in programDistributors"
                    :value="d.Id"
                    :key="d.Id"
                  >
                    {{ d.Nombre }}{{ d.ClubNombre ? ` (${d.ClubNombre})` : "" }}
                  </option>
                </b-select>
              </b-field>
            </div>
            <div class="column is-12">
              <b-field :label="i18n.coupon[iso]" label-position="on-border">
                <b-select
                  v-model="registrarCodigo.cuponId"
                  :placeholder="i18n.selectCoupon[iso]"
                  expanded
                  :loading="loadingCuponesList"
                >
                  <option
                    v-for="cuponItem in cuponesList"
                    :key="cuponItem._id"
                    :value="cuponItem._id"
                  >
                    {{ cuponItem.Nombre }}
                  </option>
                </b-select>
              </b-field>
            </div>

            <div
              class="column is-12 has-text-centered"
              v-if="errorRegistrarCodigo"
            >
              <span style="color: #f14668; font-weight: bold">{{
                errorRegistrarCodigo
              }}</span>
            </div>
          </div>
        </div>
        <footer class="card-footer">
          <a class="card-footer-item" @click="addCodeToCupon">
            <span style="color: #48c78e; font-weight: bold; font-size: 130%"
              >{{ i18n.registerCode[iso] }}</span
            >
            <b-icon
              pack="fas"
              :icon="loadingRegistrarCodigo ? 'sync-alt' : 'save'"
              type="is-success"
              :custom-class="loadingRegistrarCodigo ? 'fa-spin' : ''"
            ></b-icon>
          </a>
        </footer>
      </div>
    </b-modal>

    <!-- Modal Crear Reunión -->
    <b-modal v-model="ModalCrearReunion" :width="500" :can-cancel="['x']">
      <div class="card">
        <header class="card-header">
          <p class="card-header-title">{{ i18n.createMeeting[iso] }}</p>
          <button
            class="card-header-icon"
            aria-label="more options"
            @click="ModalCrearReunion = false"
          >
            <b-icon pack="fas" icon="times" type="is-danger"></b-icon>
          </button>
        </header>
        <div class="card-content">
          <div class="columns is-multiline">
            <div class="column is-6">
              <b-field :label="i18n.meetingTime[iso]" label-position="on-border">
                <b-timepicker
                  v-model="reunion.Hora"
                  icon="clock"
                  icon-pack="fas"
                  hour-format="12"
                  :increment-minutes="5"
                  append-to-body
                  editable
                  expanded
                ></b-timepicker>
              </b-field>
              <p class="is-size-7 mt-1" style="color: #7a7a7a; font-style: italic;">
                {{ i18n.meetingTimeNotice[iso] }}
              </p>
            </div>
            <div class="column is-6">
              <p class="is-size-7" style="color: #7a7a7a">
                {{ i18n.existingMeetingTimes[iso] }}:
              </p>
              <p class="is-size-7" v-if="loadingReuniones">
                <b-icon pack="fas" icon="sync-alt" size="is-small" custom-class="fa-spin"></b-icon>
              </p>
              <p class="is-size-7" v-else-if="!reunionesList.length" style="font-style: italic">
                {{ i18n.noMeetingTimes[iso] }}
              </p>
              <div v-else>
                <b-tag
                  v-for="r in sortedReuniones"
                  :key="`hora-${r._id}`"
                  type="is-info is-light"
                  class="mr-1 mb-1"
                >
                  {{ formatHora(r.Hora) }}
                </b-tag>
              </div>
            </div>
            <div class="column is-12">
              <b-field :label="i18n.meetingLink[iso]" label-position="on-border">
                <b-input
                  v-model="reunion.Enlace"
                  type="text"
                  expanded
                ></b-input>
              </b-field>
            </div>
            <div class="column is-12 has-text-centered" v-if="errorReunion">
              <span style="color: #f14668; font-weight: bold">{{ errorReunion }}</span>
            </div>
          </div>
        </div>
        <footer class="card-footer">
          <a class="card-footer-item" @click="crearReunion">
            <span style="color: #48c78e; font-weight: bold; font-size: 130%">{{ i18n.save[iso] }}</span>
            <b-icon
              pack="fas"
              :icon="loadingCrearReunion ? 'sync-alt' : 'save'"
              type="is-success"
              :custom-class="loadingCrearReunion ? 'fa-spin' : ''"
            ></b-icon>
          </a>
        </footer>
      </div>
    </b-modal>

    <!-- Modal Eliminar Reunión -->
    <b-modal v-model="ModalEliminarReunion" :width="500" :can-cancel="['x']">
      <div class="card">
        <header class="card-header">
          <p class="card-header-title">{{ i18n.deleteMeeting[iso] }}</p>
          <button
            class="card-header-icon"
            aria-label="more options"
            @click="ModalEliminarReunion = false"
          >
            <b-icon pack="fas" icon="times" type="is-danger"></b-icon>
          </button>
        </header>
        <div class="card-content">
          <b-field :label="i18n.selectMeeting[iso]" label-position="on-border">
            <b-select v-model="selectedReunionId" expanded :loading="loadingReuniones">
              <option
                v-for="r in sortedReuniones"
                :key="r._id"
                :value="r._id"
              >
                {{ formatHora(r.Hora) }}{{ r.Enlace ? ' - ' + r.Enlace : '' }}
              </option>
            </b-select>
          </b-field>
          <div class="has-text-centered" v-if="errorReunion" style="margin-top: 1rem;">
            <span style="color: #f14668; font-weight: bold">{{ errorReunion }}</span>
          </div>
        </div>
        <footer class="card-footer">
          <a class="card-footer-item" @click="eliminarReunion">
            <span style="color: #f14668; font-weight: bold; font-size: 130%">{{ i18n.delete[iso] || 'Eliminar' }}</span>
            <b-icon
              pack="fas"
              :icon="loadingEliminarReunion ? 'sync-alt' : 'trash'"
              type="is-danger"
              :custom-class="loadingEliminarReunion ? 'fa-spin' : ''"
            ></b-icon>
          </a>
        </footer>
      </div>
    </b-modal>

    <!-- Modal Detalle del Invitado -->
    <b-modal v-model="ModalDetalle" :width="900" :can-cancel="['x']" scroll="keep">
      <div class="card" v-if="selectedProspectoDetalle">
        <header class="card-header">
          <p class="card-header-title">
            {{ i18n.guestDetail[iso] }}: {{ selectedProspectoDetalle.Nombre }}
            {{ selectedProspectoDetalle.Apellido }}
          </p>
          <button
            class="card-header-icon"
            aria-label="more options"
            @click="ModalDetalle = false"
          >
            <b-icon pack="fas" icon="times" type="is-danger"></b-icon>
          </button>
        </header>
        <div class="card-content">
          <!-- Información general -->
          <p class="detail-title">
            <b-icon pack="fas" icon="user" size="is-small"></b-icon>
            {{ i18n.generalInformation[iso] }}
          </p>
          <div class="columns is-multiline detail-grid">
            <div
              class="column is-4"
              v-for="item in detalleGeneral"
              :key="item.label"
            >
              <p class="detail-label">{{ item.label }}</p>
              <p class="detail-value">{{ item.value }}</p>
            </div>
          </div>

          <!-- Línea de tiempo: cita, tarjeta de HubSpot y manifiesto en un solo lugar -->
          <GuestTimeline
            v-if="ModalDetalle && selectedProspectoDetalle._id"
            :key="selectedProspectoDetalle._id"
            :prospecto-id="selectedProspectoDetalle._id"
            :iso="iso"
          />

          <template v-if="isSsp(selectedProspectoDetalle)">
            <!-- Revisión: lo que el webhook de SSP registró pero hay que revisar -->
            <template v-if="tieneRevision(selectedProspectoDetalle)">
              <p class="detail-title">
                <b-icon pack="fas" icon="exclamation-triangle" size="is-small" type="is-warning"></b-icon>
                {{ ssp.reviewTitle }}
              </p>
              <b-message
                v-for="marca in selectedProspectoDetalle.Revision"
                :key="marca"
                type="is-warning"
                size="is-small"
              >
                <b>{{ ssp.reviewShort[marca] || marca }}:</b> {{ ssp.reviewDetail[marca] || "" }}
              </b-message>
            </template>

            <!-- Calificación SSP -->
            <p class="detail-title">
              <b-icon pack="fas" icon="star" size="is-small"></b-icon>
              {{ ssp.qualificationTitle }}
            </p>
            <div class="columns is-multiline detail-grid">
              <div
                class="column is-4"
                v-for="item in detalleCalificacion"
                :key="item.label"
              >
                <p class="detail-label">{{ item.label }}</p>
                <p class="detail-value">{{ item.value }}</p>
              </div>
            </div>

            <!-- Cita SSP -->
            <p class="detail-title">
              <b-icon pack="fas" icon="calendar-check" size="is-small"></b-icon>
              {{ ssp.appointmentTitle }}
            </p>
            <div class="columns is-multiline detail-grid">
              <div class="column is-4">
                <p class="detail-label">{{ ssp.appointment.status }}</p>
                <p class="detail-value">
                  <b-tag v-if="citaEstado(selectedProspectoDetalle)" :type="citaEstadoTipo(selectedProspectoDetalle)">
                    {{ citaEstadoLabel(selectedProspectoDetalle) }}
                  </b-tag>
                </p>
              </div>
              <div
                class="column is-4"
                v-for="item in detalleCita"
                :key="item.label"
              >
                <p class="detail-label">{{ item.label }}</p>
                <p class="detail-value">{{ item.value }}</p>
              </div>
            </div>
            <p class="detail-label" style="margin-bottom: 0.35rem;">{{ ssp.appointment.history }}</p>
            <b-table
              :data="historialCita"
              :striped="true"
              :hoverable="true"
              :narrowed="true"
            >
              <b-table-column :label="ssp.appointment.event" centered v-slot="props">
                {{ ssp.events[props.row.Evento] || props.row.Evento }}
              </b-table-column>
              <b-table-column :label="ssp.appointment.status" centered v-slot="props">
                {{ ssp.appointmentStatus[props.row.Estado] || props.row.Estado || "" }}
              </b-table-column>
              <b-table-column :label="ssp.appointment.appointmentDate" centered v-slot="props">
                {{ formatCancun(props.row.Inicio) }}
              </b-table-column>
              <b-table-column :label="ssp.appointment.receivedAt" centered v-slot="props">
                {{ formatCancun(props.row.FechaRecepcion) }}
              </b-table-column>
              <template #empty>
                <div class="has-text-centered">
                  <p>{{ ssp.appointment.noHistory }}</p>
                </div>
              </template>
            </b-table>

            <!-- Todo lo que mandó SSP, tal como llegó -->
            <b-collapse :open="false" animation="slide" class="mt-4">
              <template #trigger="props">
                <p class="detail-title" style="cursor: pointer;">
                  <b-icon pack="fas" :icon="props.open ? 'chevron-down' : 'chevron-right'" size="is-small"></b-icon>
                  {{ ssp.allFieldsTitle }}
                </p>
              </template>
              <b-table
                :data="camposPersonalizados"
                :striped="true"
                :hoverable="true"
                :narrowed="true"
              >
                <b-table-column :label="ssp.field" v-slot="props">
                  {{ props.row.Campo }}
                </b-table-column>
                <b-table-column :label="ssp.value" v-slot="props">
                  {{ formatValorCampo(props.row.Valor) }}
                </b-table-column>
                <template #empty>
                  <div class="has-text-centered">
                    <p>{{ ssp.noFields }}</p>
                  </div>
                </template>
              </b-table>
            </b-collapse>
          </template>

          <!-- Regalos emitidos -->
          <p class="detail-title">
            <b-icon pack="fas" icon="gift" size="is-small"></b-icon>
            {{ i18n.giftsIssued[iso] }}
          </p>
          <b-table
            :data="selectedProspectoDetalle.Cupones || []"
            :striped="true"
            :hoverable="true"
            :narrowed="true"
          >
            <b-table-column
              field="Codigo"
              :label="i18n.giftId[iso]"
              centered
              v-slot="props"
            >
              {{ (props.row.Codigo || "").toUpperCase() }}
            </b-table-column>
            <b-table-column
              field="Nombre"
              :label="i18n.name[iso]"
              centered
              v-slot="props"
            >
              {{ props.row.Nombre || "N/A" }}
            </b-table-column>
            <b-table-column
              field="Estado"
              :label="i18n.status[iso]"
              centered
              v-slot="props"
            >
              <b-tag v-if="props.row.Estado === 'pending'" type="is-warning"
                >{{ i18n.pending[iso] }}</b-tag
              >
              <b-tag v-else-if="props.row.Estado === 'active'" type="is-success"
                >{{ i18n.active[iso] }}</b-tag
              >
              <b-tag v-else-if="props.row.Estado === 'used'" type="is-info"
                >{{ i18n.used[iso] }}</b-tag
              >
              <b-tag v-else-if="props.row.Estado === 'expired'" type="is-danger"
                >{{ i18n.expired[iso] }}</b-tag
              >
              <b-tag v-else type="is-light">{{ props.row.Estado }}</b-tag>
            </b-table-column>
            <template #empty>
              <div class="has-text-centered">
                <p>{{ i18n.noCouponsForGuest[iso] }}</p>
              </div>
            </template>
          </b-table>

          <!-- Manifiesto -->
          <p class="detail-title">
            <b-icon pack="fas" icon="clipboard-list" size="is-small"></b-icon>
            {{ i18n.manifestInformation[iso] }}
          </p>
          <div class="columns is-multiline detail-grid">
            <div
              class="column is-4"
              v-for="item in detalleManifiesto"
              :key="item.label"
            >
              <p class="detail-label">{{ item.label }}</p>
              <p class="detail-value">{{ item.value }}</p>
            </div>
          </div>
        </div>
        <footer class="card-footer" v-if="$checkPermission('cap-guests-manifest')">
          <a class="card-footer-item" @click="editarManifiestoDesdeDetalle">
            <span style="color: #485fc7; font-weight: bold; font-size: 130%">{{
              i18n.manifest[iso]
            }}</span>
            <b-icon pack="fas" icon="clipboard-list" type="is-link"></b-icon>
          </a>
        </footer>
      </div>
    </b-modal>

    <!-- Modal Manifiesto -->
    <b-modal v-model="ModalManifiesto" :width="960" :can-cancel="['x']" scroll="keep">
      <div class="card" v-if="selectedProspectoManifiesto">
        <header class="card-header">
          <p class="card-header-title">
            {{ i18n.manifest[iso] }}: {{ selectedProspectoManifiesto.Nombre }}
            {{ selectedProspectoManifiesto.Apellido }}
          </p>
          <button
            class="card-header-icon"
            aria-label="more options"
            @click="ModalManifiesto = false"
          >
            <b-icon pack="fas" icon="times" type="is-danger"></b-icon>
          </button>
        </header>
        <div class="card-content">
          <div class="columns is-multiline">
            <div class="column is-4">
              <b-field :label="i18n.rating[iso]" label-position="on-border">
                <b-select v-model="manifiesto.Rating" expanded>
                  <option :value="null">{{ i18n.notAssigned[iso] }}</option>
                  <option
                    v-for="opt in ratingOptions"
                    :key="opt.value"
                    :value="opt.value"
                  >
                    {{ i18n[opt.i18nKey][iso] }}
                  </option>
                </b-select>
              </b-field>
            </div>
            <div class="column is-4">
              <b-field :label="i18n.giftType[iso]" label-position="on-border">
                <b-select v-model="manifiesto.GiftType" expanded>
                  <option value="" disabled>{{ i18n.chooseGiftTypePlaceholder[iso] }}</option>
                  <option :value="null">{{ i18n.noGift[iso] }}</option>
                  <option
                    v-for="opt in giftTypeOptions"
                    :key="opt.value"
                    :value="opt.value"
                    :disabled="opt.disabled"
                  >
                    {{ i18n[opt.i18nKey][iso] }}
                  </option>
                </b-select>
              </b-field>
            </div>
            <div class="column is-4">
              <b-field
                :label="i18n.classification[iso]"
                label-position="on-border"
              >
                <b-select v-model="manifiesto.Clasificacion" expanded>
                  <option :value="null">{{ i18n.notAssigned[iso] }}</option>
                  <option
                    v-for="opt in clasificacionOptions"
                    :key="opt"
                    :value="opt"
                  >
                    {{ opt }}
                  </option>
                </b-select>
              </b-field>
            </div>

            <div class="column is-6">
              <b-field :label="i18n.saleLabel[iso]" label-position="on-border">
                <div class="control">
                  <b-tag
                    :type="manifiestoVenta ? 'is-success' : 'is-light'"
                    size="is-medium"
                  >
                    {{ manifiestoVenta ? i18n.yes[iso] : i18n.no[iso] }}
                  </b-tag>
                </div>
              </b-field>
              <p
                class="is-size-7 mt-1"
                style="color: #7a7a7a; font-style: italic"
              >
                {{ i18n.saleAutoNotice[iso] }}
              </p>
            </div>
            <div class="column is-6">
              <b-field :label="i18n.vendor[iso]" label-position="on-border">
                <div class="control">
                  <b-tag
                    :type="manifiestoVendor ? 'is-info is-light' : 'is-light'"
                    size="is-medium"
                  >
                    {{ manifiestoVendor || i18n.notAssigned[iso] }}
                  </b-tag>
                </div>
              </b-field>
              <p
                class="is-size-7 mt-1"
                style="color: #7a7a7a; font-style: italic"
              >
                {{ i18n.vendorFromGuestNotice[iso] }}
              </p>
            </div>

            <div
              class="column is-4"
              v-for="field in staffFields"
              :key="field.key"
            >
              <b-field
                :label="i18n[field.i18nKey][iso]"
                label-position="on-border"
              >
                <b-autocomplete
                  v-model="staffQueries[field.key]"
                  :data="filteredStaff(field.key)"
                  :placeholder="i18n.searchUser[iso]"
                  :open-on-focus="true"
                  :clearable="true"
                  :loading="loadingVendedores"
                  field="displayName"
                  icon="user"
                  icon-pack="fas"
                  expanded
                  append-to-body
                  dropdown-position="auto"
                  @select="(option) => onStaffSelect(field.key, option)"
                >
                  <template #empty>{{ i18n.noUsersFound[iso] }}</template>
                </b-autocomplete>
              </b-field>
            </div>

            <div class="column is-12">
              <b-checkbox
                v-model="manifiesto.Perdido"
                type="is-danger"
                style="display: inline-flex; flex-direction: row; align-items: center"
                @input="errorManifiesto = false"
              >
                <strong>{{ i18n.markAsLost[iso] }}</strong>
              </b-checkbox>
              <p class="is-size-7 mt-1" style="color: #7a7a7a; font-style: italic">
                {{ i18n.markAsLostNotice[iso] }}
              </p>
              <b-field
                v-if="manifiesto.Perdido"
                class="mt-3"
                :label="i18n.lostReason[iso]"
                label-position="on-border"
              >
                <b-input
                  v-model="manifiesto.MotivoPerdida"
                  type="textarea"
                  rows="2"
                  maxlength="1000"
                  :placeholder="i18n.lostReasonPlaceholder[iso]"
                  @input="errorManifiesto = false"
                ></b-input>
              </b-field>
            </div>

            <div class="column is-12 has-text-centered" v-if="errorManifiesto">
              <span style="color: #f14668; font-weight: bold">{{
                errorManifiesto
              }}</span>
            </div>
          </div>
        </div>
        <footer class="card-footer">
          <a class="card-footer-item" @click="saveManifiesto">
            <span style="color: #48c78e; font-weight: bold; font-size: 130%">{{
              i18n.save[iso]
            }}</span>
            <b-icon
              pack="fas"
              :icon="loadingManifiesto ? 'sync-alt' : 'save'"
              type="is-success"
              :custom-class="loadingManifiesto ? 'fa-spin' : ''"
            ></b-icon>
          </a>
        </footer>
      </div>
    </b-modal>
    <!-- Modal Generate Payment Link -->
    <b-modal v-model="ModalGenerateLink" :width="800">
      <ModalGeneratePaymentLink
        v-if="selectedGuestForLink"
        :guest="selectedGuestForLink"
        :iso="iso"
        @close="ModalGenerateLink = false"
        @refresh="listProspectos"
      />
    </b-modal>
  </div>
</template>

<script>
import axios from "axios";
const API_URL = process.env.VUE_APP_API_URL;
import moment from "moment";
import "moment-timezone";
import i18n, { nationality } from "../../utils/i18n";
import TableList from "../../components/TableList.vue";
import ModalGeneratePaymentLink from "../../views/ModalGeneratePaymentLink.vue";
import GuestTimeline from "../../components/Capturador/GuestTimeline.vue";

const today = new Date();

export default {
  data() {
    return {
      isPaginated: true,
      isPaginationSimple: true,
      isPaginationRounded: false,
      paginationPosition: "bottom",
      defaultSortDirection: "asc",
      sortIcon: "arrow-up",
      sortIconSize: "is-small",
      currentPage: 1,
      perPage: 10,
      hasInput: false,
      paginationOrder: "",
      inputPosition: "",
      inputDebounce: "",
      isBordered: false,
      isStriped: true,
      isNarrowed: true,
      isHoverable: true,
      isFocusable: false,
      hasMobileCards: true,

      //Loading
      loadingTableList: false,
      loadingButton: false,

      //Data
      prospectos: [],
      total: 0,

      //Modals
      ModalProspecto: false,
      ModalDetalle: false,
      ModalManifiesto: false,
      ModalRegistrarCodigo: false,

      //i18n
      i18n,
      iso: null,

      //Permissions
      permissions: "",

      tabFilters: 0,
      club: null,
      filters: {
        Nombre: null,
        Apellido: null,
        Email: null,
        IdInvitado: null,
        FechaCreacion: [],
        MeetingDate: [],
        ClubId: null,
        EstadoHubSpot: null,
        Origen: null,
      },
      date: new Date(),
      minDate: new Date(
        today.getFullYear() - 80,
        today.getMonth(),
        today.getDate(),
      ),
      maxDate: new Date(
        today.getFullYear() + 18,
        today.getMonth(),
        today.getDate(),
      ),

      prospecto: {
        Nombre: null,
        Apellido: null,
        Email: null,
        Idioma: "EN",
        Lada: null,
        Telefono: null,
        Nacionalidad: null,
        Transaccion: null,
        Estado: "registered",
        DistributorId: null,
        Vendedor: null,
        MeetingId: null,
        MeetingDate: null,
      },
      editingProspecto: null,
      userDistributors: [],
      allDistributors: [],
      availableVendedores: [],
      loadingVendedores: false,
      loadingProspecto: false,
      errorProspecto: false,

      // Registrar Código
      registrarCodigo: {
        codigo: "",
        cuponId: null,
        distributorId: null,
      },
      loadingRegistrarCodigo: false,
      errorRegistrarCodigo: false,
      selectedProspecto: null,
      cuponesList: [],
      loadingCuponesList: false,

      // Detalle del invitado
      selectedProspectoDetalle: null,

      // Manifiesto
      selectedProspectoManifiesto: null,
      manifiesto: {},
      staffQueries: {},
      loadingManifiesto: false,
      errorManifiesto: false,
      // Puestos del manifiesto: cada uno se guarda como el _id del usuario.
      staffFields: [
        { key: "Greeter", i18nKey: "greeter" },
        { key: "Gifter", i18nKey: "gifter" },
        { key: "Tech", i18nKey: "tech" },
        { key: "Podium", i18nKey: "podium" },
        { key: "Closer", i18nKey: "closer" },
        { key: "SaleDirector", i18nKey: "saleDirector" },
      ],
      ratingOptions: [
        { value: "noShow", i18nKey: "ratingNoShow" },
        { value: "walkout", i18nKey: "ratingWalkout" },
        { value: "showFail", i18nKey: "ratingShowFail" },
        { value: "showWin", i18nKey: "ratingShowWin" },
      ],
      // Cruise queda listo pero deshabilitado: por ahora solo se regalan semanas.
      giftTypeOptions: [
        { value: "weeks", i18nKey: "giftTypeWeeks", disabled: false },
        { value: "cruise", i18nKey: "giftTypeCruise", disabled: true },
      ],
      clasificacionOptions: ["NQ", "Q1", "Q2"],

      // Generate Link Modal
      ModalGenerateLink: false,
      selectedGuestForLink: null,

      catPaises: [],
      loadingCatPaises: false,

      // Reuniones
      ModalCrearReunion: false,
      ModalEliminarReunion: false,
      // Lugares por reunión que valida el backend (prospecto.ctrl: >= 10 rechaza).
      // El cupo del día sale de este número por la cantidad de horarios del club.
      seatsPerMeeting: 10,
      reunion: {
        // El timepicker trabaja con Date; al guardar se manda como "HH:mm".
        Hora: null,
        Enlace: null,
      },
      reunionesList: [],
      selectedReunionId: null,
      loadingCrearReunion: false,
      loadingEliminarReunion: false,
      loadingReuniones: false,
      errorReunion: false,

      // Stages de HubSpot para filtrado
      hubspotStages: [],

      // Occupancy tracking
      guestsByDateHour: {},

      // Vendors
      availableVendors: [],
      loadingVendedores: false,
      currentUserData: null,
      vendorRoleId: "6a2b1b3a81e5baaa9b12f8a4",

      // Directorio de usuarios (id -> usuario) para resolver el Vendedor en la tabla
      usersById: {},
      // Directorio por Usuario: los puestos del manifiesto se guardan así
      usersByUsuario: {},
      // Todos los usuarios activos del club: alimentan los dropdowns del manifiesto
      allUsers: [],
      systemRoles: [],
      // Solo los usuarios con estos roles pueden ocupar un puesto del manifiesto.
      // Se comparan por nombre y no por _id porque cada club tiene su propia
      // variante del rol (VLO-HTS, admin-HTS, Staff-HTS, ...).
      manifestRolePrefixes: ["vlo", "admin", "staff"],
    };
  },
  async created() {
    this.iso = localStorage.getItem("iso");
    this.$bus.on("change-iso", () => {
      this.iso = localStorage.getItem("iso");
    });

    this.$bus.on("change-club", () => {
      this.getClub();
    });

    await this.getClub();
    this.loadUserDistributors();
    if (this.isAdmin) await this.loadAllDistributors();

    //Permissions
    this.permissions = localStorage.getItem("role");

    this.getCatPaises();

    this.loadHubspotStages();
    this.loadAvailableVendors();
    this.loadSystemRoles();
    this.listProspectos();
  },
  components: {
    TableList,
    ModalGeneratePaymentLink,
    GuestTimeline,
  },
  computed: {
    isProspectoPaid() {
      if (!this.prospecto) return false;
      return this.prospecto.isPaid || this.prospecto.Estado === 'pendingToSign' || this.prospecto.Estado === 'won' || (this.prospecto.Autocompletado && this.prospecto.Autocompletado.Pagado);
    },
    isAdmin() {
      return localStorage.getItem("role") === "admin";
    },
    // Textos de los leads de Sales Systems Pros en el idioma actual
    ssp() {
      return i18n.sspLead[this.iso] || i18n.sspLead.en;
    },
    detalleCalificacion() {
      const c = this.selectedProspectoDetalle?.Calificacion || {};
      const campos = [
        "LeadChannel",
        "VendorSource",
        "QnqStatus",
        "LeadQualityScore",
        "LeadQualityRating",
        "HouseholdIncome",
        "AgeRange",
        "CitizenshipResidency",
        "TripsPerYear",
        "OtaBookingHistory",
        "OtaSpendLast12Months",
        "ComfortableTripBudget",
        "MembershipPurchaseLikelihood",
        "RelationshipStatus",
        "SpouseFullName",
        "DreamDestination",
        "DreamTripBarrier",
        "TravelCompanion",
        "ContactSource",
        "UsuarioAsignado",
        "PresentationAttendanceRequirements",
      ];
      const rows = campos.map((campo) => ({
        label: this.ssp.fields[campo],
        value: c[campo] ?? null,
      }));
      rows.push({
        label: this.ssp.fields.Tags,
        value: Array.isArray(c.Tags) ? c.Tags.join(", ") : null,
      });
      return rows;
    },
    detalleCita() {
      const row = this.selectedProspectoDetalle;
      const cita = row?.Cita || {};
      const hora = row?.MeetingId && row.MeetingId.Hora ? this.formatHora(row.MeetingId.Hora) : null;
      return [
        {
          label: `${this.ssp.appointment.datetime} (${this.ssp.appointment.cancunTime})`,
          value: this.formatCancun(cita.Inicio),
        },
        {
          label: this.ssp.appointment.session,
          value: hora || this.ssp.appointment.noSession,
        },
        { label: this.ssp.appointment.calendar, value: cita.Calendario || null },
        { label: this.ssp.appointment.link, value: cita.Enlace || null },
      ];
    },
    // El más reciente primero
    historialCita() {
      const historial = this.selectedProspectoDetalle?.Cita?.Historial;
      return Array.isArray(historial) ? [...historial].reverse() : [];
    },
    camposPersonalizados() {
      const campos = this.selectedProspectoDetalle?.Calificacion?.CamposPersonalizados;
      return Array.isArray(campos) ? campos : [];
    },
    programDistributors() {
      return this.isAdmin ? this.allDistributors : this.userDistributors;
    },
    uniqueLadas() {
      if (!this.catPaises || this.catPaises.length === 0) return [];
      const ladas = [];
      for (const pais of this.catPaises) {
        if (!ladas.find((l) => l.Lada === pais.Lada)) {
          ladas.push(pais);
        }
      }
      return ladas.sort((a, b) =>
        a.Lada > b.Lada ? 1 : b.Lada > a.Lada ? -1 : 0
      );
    },
    sortedPaises() {
      if (!this.catPaises || this.catPaises.length === 0) return [];
      let tmp = [...this.catPaises];
      const can = tmp.find((d) => d.Id === "CAN");
      const usa = tmp.find((d) => d.Id === "USA");
      return [
        usa,
        can,
        ...tmp
          .filter((d) => d.Id !== "USA" && d.Id !== "CAN")
          .sort((a, b) => {
            const nameA =
              this.iso === "es"
                ? a.Nacionalidad?.split(" ")[0]
                : a.NacionalidadEn?.split(" ")[0];
            const nameB =
              this.iso === "es"
                ? b.Nacionalidad?.split(" ")[0]
                : b.NacionalidadEn?.split(" ")[0];
            if (!nameA) return 1;
            if (!nameB) return -1;
            return nameA > nameB ? 1 : nameA < nameB ? -1 : 0;
          }),
      ].filter(Boolean);
    },
    meetingDateEvents() {
      const events = {};
      const dates = new Set();

      Object.keys(this.guestsByDateHour).forEach((key) => {
        const [dateStr] = key.split('_');
        dates.add(dateStr);
      });

      dates.forEach((dateStr) => {
        const date = new Date(dateStr + "T00:00:00");
        const dayOccupancy = this.getDayOccupancy(date);

        let type = "is-success";
        if (dayOccupancy >= this.dayCapacity) type = "is-danger";
        else if (dayOccupancy >= this.dayWarningThreshold) type = "is-warning";

        events[dateStr] = { date, type };
      });

      return Object.values(events);
    },
    // Los horarios se administran desde el modal de crear reunión, así que la
    // lista puede traer cualquier hora y en cualquier orden: se ordena aquí.
    sortedReuniones() {
      return [...this.reunionesList].sort(
        (a, b) => this.horaToMinutes(a.Hora) - this.horaToMinutes(b.Hora)
      );
    },
    // Cupo del día = lugares por reunión x horarios configurados del club.
    dayCapacity() {
      return Math.max(1, this.reunionesList.length) * this.seatsPerMeeting;
    },
    dayWarningThreshold() {
      return Math.ceil(this.dayCapacity / 2);
    },
    hourOptions() {
      if (!this.prospecto.MeetingDate) return [];

      return this.sortedReuniones.map((meeting) => {
        const occupancy = this.getHourOccupancy(this.prospecto.MeetingDate, meeting._id);
        const dayOccupancy = this.getDayOccupancy(this.prospecto.MeetingDate);
        const availableInHour = Math.max(0, this.seatsPerMeeting - occupancy);
        const isHourFull = occupancy >= this.seatsPerMeeting;
        const isDayFull = dayOccupancy >= this.dayCapacity;

        return {
          ...meeting,
          occupancy,
          availableInHour,
          dayOccupancy,
          isDisabled: isHourFull || isDayFull,
        };
      });
    },
    isCurrentUserVendor() {
      if (!this.currentUserData || !this.currentUserData.Rol) return false;
      return this.currentUserData.Rol === this.vendorRoleId;
    },
    displayVendors() {
      if (this.isCurrentUserVendor && this.currentUserData) {
        return [this.currentUserData];
      }
      return this.availableVendors;
    },
    manifestRoleIds() {
      return this.systemRoles
        .filter((r) =>
          this.manifestRolePrefixes.some((prefijo) =>
            String(r.Nombre || "")
              .toLowerCase()
              .startsWith(prefijo),
          ),
        )
        .map((r) => String(r._id));
    },
    // Usuarios con nombre listo para mostrar/buscar en los autocompletes.
    staffOptions() {
      const rolesPermitidos = this.manifestRoleIds;
      return this.allUsers
        // Si los roles no cargaron se muestran todos: es preferible a dejar
        // los dropdowns vacíos y bloquear la captura.
        .filter(
          (u) =>
            !rolesPermitidos.length ||
            rolesPermitidos.includes(String(u.Rol)),
        )
        .map((u) => ({ ...u, displayName: this.getUserName(u) }))
        .filter((u) => u.displayName)
        .sort((a, b) => a.displayName.localeCompare(b.displayName));
    },
    // La venta no se captura: se deduce de si el invitado ya tiene contrato.
    manifiestoVenta() {
      return !!this.selectedProspectoManifiesto?.ContractId;
    },
    // El vendor tampoco se captura aquí: es el que trae el invitado.
    manifiestoVendor() {
      return this.getVendorName(this.selectedProspectoManifiesto);
    },
    detalleGeneral() {
      const row = this.selectedProspectoDetalle;
      if (!row) return [];
      return [
        { label: i18n.guestId[this.iso], value: row.IdInvitado },
        { label: i18n.name[this.iso], value: row.Nombre },
        { label: i18n.lastname[this.iso], value: row.Apellido },
        { label: i18n.email[this.iso], value: row.Email },
        { label: i18n.phone[this.iso], value: row.Telefono },
        {
          label: i18n.meetingDateTime[this.iso],
          value: this.getMeetingDateTime(row),
        },
        {
          label: i18n.stage[this.iso],
          value: row.EstadoHubSpot
            ? this.getStageTranslation(row.EstadoHubSpot, this.iso)
            : null,
        },
        { label: i18n.language[this.iso], value: row.Idioma },
        { label: i18n.contract[this.iso], value: row.ContractId },
        { label: i18n.notes[this.iso], value: row.Transaccion },
      ];
    },
    detalleManifiesto() {
      if (!this.selectedProspectoDetalle) return [];
      // Aunque no haya manifiesto capturado se listan los campos en N/A,
      // así el Vendor siempre se ve en esta sección.
      const m = this.selectedProspectoDetalle.Manifiesto || {};
      const rows = [
        { label: i18n.rating[this.iso], value: this.ratingLabel(m.Rating) },
        {
          label: i18n.giftType[this.iso],
          value: this.giftTypeLabel(m.GiftType),
        },
        { label: i18n.classification[this.iso], value: m.Clasificacion },
        {
          label: i18n.markAsLost[this.iso],
          value: m.Perdido ? `${i18n.yes[this.iso]}: ${m.MotivoPerdida || ""}` : i18n.no[this.iso],
        },
        {
          label: i18n.saleLabel[this.iso],
          // Igual que en el modal: la venta se deduce del contrato.
          value: this.selectedProspectoDetalle.ContractId
            ? i18n.yes[this.iso]
            : i18n.no[this.iso],
        },
      ];
      // El vendor no se captura en el manifiesto: se arrastra del invitado.
      rows.push({
        label: i18n.vendor[this.iso],
        value: this.getVendorName(this.selectedProspectoDetalle),
      });
      this.staffFields.forEach((field) => {
        rows.push({
          label: i18n[field.i18nKey][this.iso],
          value: this.getStaffName(m[field.key]),
        });
      });
      return rows;
    },
  },
  methods: {
    openModalPaymentLink(row) {
      this.selectedGuestForLink = row;
      this.ModalGenerateLink = true;
    },
    async getCatPaises() {
      try {
        this.loadingCatPaises = true;
        const { data } = await axios.get(`${API_URL}/catalogue/CatPaises`);
        this.catPaises = data;
      } catch (err) {
        console.error(err);
      } finally {
        this.loadingCatPaises = false;
      }
    },
    getClub() {
      let club = localStorage.getItem("club");
      club = club ? JSON.parse(club) : {};
      this.club = club;
    },
    async loadAllDistributors() {
      try {
        const params = { Activo: true };
        if (this.club?.Id) params.ClubId = this.club.Id;
        const { data } = await axios.get(
          `${API_URL}/system/distributor/list`,
          { params },
        );
        const list = data?.data || data || [];
        const clubNombre = this.club?.Nombre || null;
        this.allDistributors = (Array.isArray(list) ? list : []).map((d) => ({
          ...d,
          ClubNombre: clubNombre,
        }));
      } catch (err) {
        console.error("Error loading all distributors:", err);
        this.allDistributors = [];
      }
    },
    loadUserDistributors() {
      try {
        const raw = localStorage.getItem("distributors");
        const list = raw ? JSON.parse(raw) : [];
        this.userDistributors = Array.isArray(list) ? list : [];
        if (this.userDistributors.length === 1) {
          this.prospecto.DistributorId = this.userDistributors[0].Id;
        }
      } catch (e) {
        this.userDistributors = [];
      }
    },
    async listProspectos() {
      try {
        this.loadingTableList = true;

        let query = `?limit=${this.perPage}&page=${this.currentPage}&sort=-FechaCreacion`;

        // Include ClubId in filters
        const role = localStorage.getItem("role");
        const currentUser = localStorage.getItem("user");
        const filtersToSend = {
          ...this.filters,
          ClubId: this.club?.Id || null,
        };

        // Normalizar el rango de Meeting Date a timestamps UTC (día completo).
        // MeetingDate se guarda a medianoche UTC, por eso usamos límites UTC.
        if (
          Array.isArray(this.filters.MeetingDate) &&
          this.filters.MeetingDate.length === 2 &&
          this.filters.MeetingDate[0] &&
          this.filters.MeetingDate[1]
        ) {
          const [start, end] = this.filters.MeetingDate;
          const startUTC = Date.UTC(
            start.getFullYear(),
            start.getMonth(),
            start.getDate(),
            0, 0, 0, 0,
          );
          const endUTC = Date.UTC(
            end.getFullYear(),
            end.getMonth(),
            end.getDate(),
            23, 59, 59, 999,
          );
          filtersToSend.MeetingDate = [startUTC, endUTC];
        } else {
          delete filtersToSend.MeetingDate;
        }

        // Si es vendor, cargar datos y filtrar solo lo que el creó
        if (!this.currentUserData && role !== "admin") {
          await this.loadCurrentUserData();
        }

        if (this.currentUserData && this.currentUserData.Rol === this.vendorRoleId) {
          filtersToSend.CreadoPor = currentUser;
        }

        if (role !== "admin") {
          filtersToSend.DistributorIds = this.userDistributors.map((d) => d.Id);
        }

        const { data } = await axios.post(
          `${API_URL}/prospectos/list${query}`,
          filtersToSend,
        );

        console.log("Prospectos data:", data);

        if (Array.isArray(data)) {
          this.prospectos = data;
          this.total = data.length;
        } else if (data?.prospectos) {
          this.prospectos = data.prospectos;
          this.total = data.total || data.prospectos.length;
        } else if (data?.docs) {
          this.prospectos = data.docs;
          this.total = data.totalDocs || data.docs.length;
        } else {
          this.prospectos = [];
          this.total = 0;
        }

        this.loadingTableList = false;
      } catch (err) {
        this.loadingTableList = false;
        console.log(err);
        this.$buefy.toast.open({
          message: i18n.errorLoadingGuests[this.iso],
          type: "is-danger",
        });
      }
    },
    savePerPage() {
      // localStorage.setItem("perPageReserves", this.perPage);
      // this.listProspectos();
    },
    onPageChange(page) {
      this.currentPage = page;
      this.listProspectos();
    },
    // Valor comparable = fecha (medianoche) + hora de la reunión.
    // MeetingDate solo guarda el día, así que sumamos la hora de MeetingId.Hora
    // para desempatar invitados del mismo día (la más temprana primero).
    meetingDateTimeValue(row) {
      if (!row || !row.MeetingDate) return null;
      const ms = Number(row.MeetingDate);
      if (isNaN(ms)) return null;
      const hora = row.MeetingId && row.MeetingId.Hora ? row.MeetingId.Hora : null;
      if (hora) {
        const [h, m] = hora.split(":").map((n) => parseInt(n, 10));
        if (!isNaN(h)) {
          return ms + (h * 60 + (isNaN(m) ? 0 : m)) * 60 * 1000;
        }
      }
      return ms;
    },
    sortByMeetingDateTime(a, b, isAsc) {
      const va = this.meetingDateTimeValue(a);
      const vb = this.meetingDateTimeValue(b);
      // Los invitados sin fecha (N/A) siempre van al final.
      if (va === null && vb === null) return 0;
      if (va === null) return 1;
      if (vb === null) return -1;
      return isAsc ? va - vb : vb - va;
    },
    parseDate(value) {
      moment.locale(this.iso);
      return value ? moment(value).format("MMMM D, YYYY") : "";
    },
    async openModalCrear() {
      this.editingProspecto = null;
      this.errorProspecto = false;
      this.availableVendedores = [];
      const list = this.programDistributors;
      const defaultDistId = list.length === 1 ? list[0].Id : null;
      this.prospecto = {
        Nombre: null,
        Apellido: null,
        Email: null,
        Idioma: "EN",
        Lada: null,
        Telefono: null,
        Nacionalidad: null,
        Transaccion: null,
        Estado: "registered",
        DistributorId: defaultDistId,
        Vendedor: null,
        MeetingId: null,
        MeetingDate: null,
      };
      // El modal se abre de inmediato y los catálogos se piden en paralelo:
      // cada select muestra su propio loading mientras llegan.
      this.ModalProspecto = true;
      await Promise.all([
        this.listReuniones(),
        this.loadOccupancy(),
        this.loadCurrentUserData(),
        this.loadAvailableVendors(),
        defaultDistId ? this.loadVendedores(defaultDistId) : null,
      ]);
    },
    async openModalEditar(row) {
      // El botón ya está deshabilitado; esto cubre cualquier otra forma de abrir el modal
      if (this.isSsp(row)) return;
      this.editingProspecto = row;
      this.errorProspecto = false;
      const { lada, phone } = this.splitPhoneNumber(row.Telefono);

      this.prospecto = {
        Nombre: row.Nombre || null,
        Apellido: row.Apellido || null,
        Email: row.Email || null,
        Idioma: row.Idioma || "EN",
        Lada: lada,
        Telefono: phone,
        Nacionalidad: row.Nacionalidad || null,
        Transaccion: row.Transaccion || null,
        Estado: row.Estado || "registered",
        DistributorId: row.DistributorId || null,
        Vendedor: row.Vendedor || null,
        MeetingId: row.MeetingId ? row.MeetingId._id || row.MeetingId : null,
        isPaid: row.isPaid || false,
        Autocompletado: row.Autocompletado || null,
        MeetingDate: this.meetingDateToPickerDate(row.MeetingDate),
      };
      // Mismo criterio que en openModalCrear: abrir ya y cargar en paralelo.
      this.ModalProspecto = true;
      await Promise.all([
        this.listReuniones(),
        this.loadOccupancy(),
        this.loadCurrentUserData(),
        this.loadAvailableVendors(),
        this.prospecto.DistributorId
          ? this.loadVendedores(this.prospecto.DistributorId)
          : null,
      ]);
    },
    async onDistributorChange(distId) {
      this.prospecto.Vendedor = null;
      this.availableVendedores = [];
      if (distId) await this.loadVendedores(distId);
    },
    async loadVendedores(distributorId) {
      try {
        this.loadingVendedores = true;
        const { data } = await axios.get(
          `${API_URL}/system/users-by-distributor/${distributorId}`,
        );
        this.availableVendedores = data?.data || [];
      } catch (err) {
        console.error("Error loading vendedores:", err);
        this.availableVendedores = [];
      } finally {
        this.loadingVendedores = false;
      }
    },
    async saveProspecto() {
      try {
        if (
          this.programDistributors.length > 1 &&
          !this.prospecto.DistributorId
        ) {
          this.errorProspecto = i18n.selectProgramError[this.iso];
          return;
        }
        if (!this.prospecto.Vendedor) {
          this.errorProspecto = i18n.selectSellerError[this.iso];
          return;
        }
        this.loadingProspecto = true;
        const phoneFinal =
          this.prospecto.Lada && this.prospecto.Telefono
            ? `+${this.prospecto.Lada}${this.prospecto.Telefono}`
            : this.prospecto.Telefono;

        // El día visual seleccionado se guarda como la marca del día de México.
        const meetingDateUnix = this.pickerDateToMeetingDate(
          this.prospecto.MeetingDate,
        );

        if (this.editingProspecto) {
          await axios.put(
            `${API_URL}/prospectos/${this.editingProspecto._id}`,
            {
              ...this.prospecto,
              Telefono: phoneFinal,
              MeetingDate: meetingDateUnix,
              ModificadoPor: localStorage.getItem("user") || null,
            },
          );
        } else {
          await axios.post(`${API_URL}/prospectos/create`, {
            ...this.prospecto,
            Telefono: phoneFinal,
            ClubId: this.club?.Id || null,
            CreadoPor: localStorage.getItem("user"),
            MeetingDate: meetingDateUnix,
          });
        }

        this.loadingProspecto = false;
        this.ModalProspecto = false;
        this.editingProspecto = null;

        this.listProspectos();

        this.$buefy.dialog.alert({
          message: this.editingProspecto
            ? i18n.guestUpdated[this.iso]
            : i18n.guestCreated[this.iso],
          type: "is-success",
          hasIcon: true,
          icon: "check",
          iconPack: "fas",
          ariaRole: "alertdialog",
          ariaModal: true,
        });
      } catch (err) {
        console.log(err);
        this.loadingProspecto = false;
        const msg = err?.response?.data?.error || err?.response?.data?.message;
        this.errorProspecto = msg || i18n.errorSavingGuest[this.iso];
      }
    },
    async openModalRegistrarCodigo(prospecto) {
      this.selectedProspecto = prospecto;
      const defaultDistId =
        this.programDistributors.length === 1
          ? this.programDistributors[0].Id
          : prospecto?.DistributorId || null;
      this.registrarCodigo = {
        codigo: "",
        cuponId: null,
        distributorId: defaultDistId,
      };
      this.errorRegistrarCodigo = false;
      this.ModalRegistrarCodigo = true;
      await this.fetchCuponesList();
    },
    async fetchCuponesList() {
      try {
        this.loadingCuponesList = true;
        const payload = { Estado: "active" };
        if (this.club?.Id) payload.ClubId = this.club.Id;
        if (this.registrarCodigo.distributorId) {
          payload.DistributorIds = [this.registrarCodigo.distributorId];
        } else if (!this.isAdmin) {
          payload.DistributorIds = this.userDistributors.map((d) => d.Id);
        }
        const { data } = await axios.post(`${API_URL}/cupones/list`, payload);

        if (Array.isArray(data)) {
          this.cuponesList = data;
        } else if (data?.cupones) {
          this.cuponesList = data.cupones;
        } else if (data?.docs) {
          this.cuponesList = data.docs;
        } else {
          this.cuponesList = [];
        }

        this.loadingCuponesList = false;
      } catch (err) {
        this.loadingCuponesList = false;
        console.log(err);
        this.$buefy.toast.open({
          message: i18n.errorLoadingCoupons[this.iso],
          type: "is-danger",
        });
      }
    },
    async addCodeToCupon() {
      try {
        if (!this.registrarCodigo.cuponId) {
          this.errorRegistrarCodigo = i18n.selectCouponError[this.iso];
          return;
        }

        this.loadingRegistrarCodigo = true;

        // Tomar Email del invitado seleccionado
        const prospectoEmail = this.selectedProspecto?.Email;
        const emailArray = prospectoEmail ? [prospectoEmail] : [];

        const payload = {
          Codigo: this.registrarCodigo.codigo || undefined,
          Email: emailArray,
        };

        await axios.put(
          `${API_URL}/cupones/add-code/${this.registrarCodigo.cuponId}`,
          payload,
        );

        this.loadingRegistrarCodigo = false;
        this.ModalRegistrarCodigo = false;
        this.$buefy.toast.open({
          message: i18n.codeRegisteredSuccess[this.iso],
          type: "is-success",
        });
        this.listProspectos();
      } catch (err) {
        console.log(err);
        this.loadingRegistrarCodigo = false;
        const msg = err?.response?.data?.error || err?.response?.data?.message;
        this.errorRegistrarCodigo = msg || i18n.errorRegisteringCode[this.iso];
      }
    },
    async clearFilters() {
      this.filters = {
        Nombre: null,
        Apellido: null,
        Email: null,
        IdInvitado: null,
        FechaCreacion: [],
        MeetingDate: [],
        ClubId: null,
        EstadoHubSpot: null,
        Origen: null,
      };
      await this.listProspectos();
    },
    onFilterChange() {
      this.currentPage = 1;
      this.listProspectos();
    },
    getStageTranslation(stage, iso) {
      const translations = i18n.hubspotStagesTranslation[iso] || i18n.hubspotStagesTranslation.en;
      return translations[stage] || stage;
    },
    // ---- Manejo de la fecha de reunión (día de México) ----
    // MeetingDate se guarda como la medianoche UTC del día de México en que se
    // da la reunión: es una marca de DÍA, no un instante. El día que se muestra
    // se lee siempre de esa marca (getUTC*), nunca de la zona horaria del SO.
    //
    // El datepicker de Buefy es la única excepción: pinta el calendario con la
    // hora local del navegador, así que se le entrega un Date a medianoche LOCAL
    // cuyo día coincide con el día de México. Ese Date sirve solo para dibujar;
    // al guardar se vuelve a convertir con pickerDateToMeetingDate().
    meetingDateToPickerDate(timestamp) {
      if (timestamp === null || timestamp === undefined || timestamp === "") return null;
      const ms = Number(timestamp);
      if (isNaN(ms)) return null;
      const marca = new Date(ms);
      return new Date(
        marca.getUTCFullYear(),
        marca.getUTCMonth(),
        marca.getUTCDate(),
        0, 0, 0, 0,
      );
    },
    pickerDateToMeetingDate(date) {
      if (!date) return null;
      return Date.UTC(
        date.getFullYear(),
        date.getMonth(),
        date.getDate(),
        0, 0, 0, 0,
      );
    },
    // Clave YYYY-MM-DD del día que el usuario ve en el datepicker.
    pickerDateKey(date) {
      if (!date) return "";
      const month = `${date.getMonth() + 1}`.padStart(2, "0");
      const day = `${date.getDate()}`.padStart(2, "0");
      return `${date.getFullYear()}-${month}-${day}`;
    },
    getTodayStart() {
      // Obtener el día de hoy en México
      const todayMexico = moment.tz("America/Mexico_City").startOf('day');
      const year = todayMexico.year();
      const month = todayMexico.month();
      const date = todayMexico.date();

      // Crear un Date que sea ese día a las 00:00 en zona horaria local
      // Así el datepicker muestra las mismas fechas mínimas en cualquier zona horaria
      return new Date(year, month, date, 0, 0, 0, 0);
    },
    getMeetingDateTime(prospecto) {
      if (!prospecto || !prospecto.MeetingDate) return "N/A";

      // moment.utc: el día se lee de la marca guardada (día de México),
      // no de la zona horaria del navegador.
      moment.locale(this.iso);
      let dateStr = "";
      if (this.iso === "es") {
        dateStr = moment.utc(prospecto.MeetingDate).format("DD/MM/YYYY");
      } else {
        dateStr = moment.utc(prospecto.MeetingDate).format("MM/DD/YYYY");
      }

      if (prospecto.MeetingId && prospecto.MeetingId.Hora) {
        return `${dateStr} ${prospecto.MeetingId.Hora}`;
      }
      return dateStr;
    },
    formatMeetingDate(timestamp, meetingTime) {
      if (!timestamp) return "";
      moment.locale(this.iso);
      let dateStr = "";
      if (this.iso === "es") {
        dateStr = moment(timestamp).format("DD/MM/YYYY");
      } else {
        dateStr = moment(timestamp).format("MM/DD/YYYY");
      }

      if (meetingTime) {
        return `${dateStr} ${meetingTime}`;
      }
      return dateStr;
    },
    goPath(path) {
      this.$router.push(path);
    },
    openModalDetalle(prospecto) {
      this.selectedProspectoDetalle = prospecto;
      this.ModalDetalle = true;
      // El directorio de usuarios resuelve los nombres del manifiesto.
      if (!this.allUsers.length) this.loadAvailableVendors();
    },
    openModalManifiesto(prospecto) {
      this.selectedProspectoManifiesto = prospecto;
      this.errorManifiesto = false;
      const guardado = prospecto?.Manifiesto || {};

      this.manifiesto = {
        Rating: guardado.Rating || null,
        // Sin elegir ("") hasta que se escoja; en una venta guardada, null es "No gift"
        GiftType: guardado.Rating === "showWin" ? guardado.GiftType ?? null : guardado.GiftType || "",
        Clasificacion: guardado.Clasificacion || null,
        Perdido: guardado.Perdido === true,
        MotivoPerdida: guardado.MotivoPerdida || "",
      };
      const queries = {};
      this.staffFields.forEach((field) => {
        this.$set(this.manifiesto, field.key, guardado[field.key] || null);
        queries[field.key] = this.getStaffName(guardado[field.key]);
      });
      this.staffQueries = queries;

      this.ModalManifiesto = true;
      if (!this.allUsers.length) this.loadAvailableVendors();
      if (!this.systemRoles.length) this.loadSystemRoles();
    },
    editarManifiestoDesdeDetalle() {
      this.openModalManifiesto(this.selectedProspectoDetalle);
    },
    filteredStaff(fieldKey) {
      const query = (this.staffQueries[fieldKey] || "").toLowerCase().trim();
      if (!query) return this.staffOptions;
      return this.staffOptions.filter((u) =>
        u.displayName.toLowerCase().includes(query),
      );
    },
    onStaffSelect(fieldKey, option) {
      this.$set(this.manifiesto, fieldKey, option ? option.Usuario : null);
    },
    ratingLabel(value) {
      const opt = this.ratingOptions.find((o) => o.value === value);
      return opt ? i18n[opt.i18nKey][this.iso] : "";
    },
    giftTypeLabel(value) {
      const opt = this.giftTypeOptions.find((o) => o.value === value);
      return opt ? i18n[opt.i18nKey][this.iso] : "";
    },
    async saveManifiesto() {
      try {
        this.errorManifiesto = false;
        const motivoPerdida = (this.manifiesto.MotivoPerdida || "").trim();
        if (this.manifiesto.Perdido && !motivoPerdida) {
          this.errorManifiesto = i18n.lostReasonRequired[this.iso];
          return;
        }
        // En una venta, el regalo se elige a propósito: "Weeks" o "No gift" mandan correos distintos
        if (this.manifiesto.Rating === "showWin" && this.manifiesto.GiftType === "") {
          this.errorManifiesto = i18n.chooseGiftTypeRequired[this.iso];
          return;
        }
        this.loadingManifiesto = true;

        const payload = {
          Rating: this.manifiesto.Rating || null,
          GiftType: this.manifiesto.GiftType || null,
          Clasificacion: this.manifiesto.Clasificacion || null,
          Venta: this.manifiestoVenta,
          Perdido: this.manifiesto.Perdido === true,
          MotivoPerdida: this.manifiesto.Perdido ? motivoPerdida : null,
        };

        this.staffFields.forEach((field) => {
          const query = (this.staffQueries[field.key] || "").trim();
          if (!query) {
            payload[field.key] = null;
            return;
          }
          // Manda el usuario que se eligió en la lista, no el nombre escrito:
          // hay usuarios homónimos y buscar por texto guardaría al equivocado.
          const elegidoUsuario = this.manifiesto[field.key];
          const elegido = elegidoUsuario
            ? this.staffOptions.find((u) => u.Usuario === elegidoUsuario)
            : null;
          if (
            elegido &&
            elegido.displayName.toLowerCase() === query.toLowerCase()
          ) {
            payload[field.key] = elegido.Usuario;
            return;
          }
          // Si el texto ya no corresponde a lo elegido, se resuelve por nombre
          // y si nada coincide el puesto queda vacío.
          const match = this.staffOptions.find(
            (u) => u.displayName.toLowerCase() === query.toLowerCase(),
          );
          payload[field.key] = match ? match.Usuario : null;
        });

        // Si al guardar la tarjeta llega a una etapa con regalo, HubSpot se lo envía
        // al invitado: se confirma antes, porque un Rating equivocado ya no se puede retirar.
        const regalo = this.regaloAlGuardar(this.selectedProspectoManifiesto, payload);
        // Un segundo regalo llega con el mismo código y el primero no se retira: solo lo confirman
        // un admin o quien tenga el permiso (VLO de HTS)
        if (regalo?.segundo && !this.$checkPermission("cap-guests-second-gift")) {
          this.errorManifiesto = i18n.secondGiftBlocked[this.iso].replace("{anterior}", i18n.giftNames[this.iso][regalo.anterior]);
          this.loadingManifiesto = false;
          return;
        }
        if (regalo && !(await (regalo.segundo ? this.confirmarSegundoRegalo(regalo) : this.confirmarRegalo(regalo)))) {
          this.loadingManifiesto = false;
          return;
        }

        await axios.put(`${API_URL}/prospectos/${this.selectedProspectoManifiesto._id}`, {
          Manifiesto: payload,
          // Quién lo guarda, para la línea de tiempo del guest
          ModificadoPor: localStorage.getItem("user") || null,
          ...(regalo?.segundo ? { ConfirmarSegundoRegalo: true } : {}),
        });

        // Reflejar el cambio en la fila abierta sin esperar al refresh.
        this.$set(this.selectedProspectoManifiesto, "Manifiesto", payload);

        this.loadingManifiesto = false;
        this.ModalManifiesto = false;
        this.$buefy.toast.open({
          message: i18n.manifestSaved[this.iso],
          type: "is-success",
        });
        this.listProspectos();
      } catch (err) {
        console.error("Error saving manifest:", err);
        this.loadingManifiesto = false;
        const msg = err?.response?.data?.error || err?.response?.data?.message;
        this.errorManifiesto = msg || i18n.errorSavingManifest[this.iso];
      }
    },
    // Misma regla que la API (services/hubspot/prospectoEtapa.service): etapa que
    // corresponde al manifiesto y regalo que HubSpot envía al llegar a ella.
    etapaManifiesto(m) {
      if (!m) return null;
      if (m.Perdido) return "perdido";
      if (m.Rating === "showWin") return m.GiftType ? "ventaConRegalo" : "ventaSinRegalo";
      return m.Rating || null;
    },
    regaloAlGuardar(row, nuevo) {
      if (!row?.HsData?.id_hs_deal) return null;
      const antes = this.etapaManifiesto(row.Manifiesto);
      const despues = this.etapaManifiesto(nuevo);
      if (antes === despues) return null;
      const etapaActual = row.EstadoHubSpot || null;
      const deshaciendoPerdido = antes === "perdido";
      const protegidas = ["Contract Sent", "Contract Signed", "Payment Completed – Closed Won"];
      if (protegidas.includes(etapaActual)) return null;
      if (etapaActual === "Closed Lost" && !deshaciendoPerdido) return null;
      const regalos = {
        showFail: { tipo: "noCompletada", etapa: "Show Complete No Sale" },
        ventaConRegalo: { tipo: "completada", etapa: "Sale & Gift" },
        ventaSinRegalo: { tipo: "sinRegalo", etapa: "Sale No Gift" },
      };
      const regalo = regalos[despues];
      if (!regalo) return null;
      // La tarjeta ya estaba en una etapa con regalo: ese correo ya salió y este sería el segundo
      const anterior = Object.values(regalos).find((r) => r.etapa === etapaActual && regalos[antes] === r);
      return { ...regalo, email: row.Email, segundo: Boolean(anterior), anterior: anterior?.tipo };
    },
    confirmarSegundoRegalo(regalo) {
      const escapar = (texto) =>
        String(texto || "").replace(/[&<>"']/g, (c) => ({ "&": "&amp;", "<": "&lt;", ">": "&gt;", '"': "&quot;", "'": "&#39;" })[c]);
      const message = i18n.secondGiftText[this.iso]
        .replace("{email}", `<b>${escapar(regalo.email)}</b>`)
        .replace("{anterior}", `<b>${i18n.giftNames[this.iso][regalo.anterior]}</b>`)
        .replace("{regalo}", `<b>${i18n.giftNames[this.iso][regalo.tipo]}</b>`);
      return new Promise((resolve) => {
        this.$buefy.dialog.confirm({
          title: i18n.secondGiftTitle[this.iso],
          message,
          confirmText: i18n.secondGiftOk[this.iso],
          cancelText: i18n.giftConfirmCancel[this.iso],
          type: "is-danger",
          hasIcon: true,
          onConfirm: () => resolve(true),
          onCancel: () => resolve(false),
        });
      });
    },
    confirmarRegalo(regalo) {
      const escapar = (texto) =>
        String(texto || "").replace(/[&<>"']/g, (c) => ({ "&": "&amp;", "<": "&lt;", ">": "&gt;", '"': "&quot;", "'": "&#39;" })[c]);
      const etapa = this.getStageTranslation(regalo.etapa, this.iso) || regalo.etapa;
      const message = i18n.giftConfirmText[this.iso]
        .replace("{etapa}", `<b>${escapar(etapa)}</b>`)
        .replace("{email}", `<b>${escapar(regalo.email)}</b>`)
        .replace("{regalo}", `<b>${i18n.giftNames[this.iso][regalo.tipo]}</b>`);
      return new Promise((resolve) => {
        this.$buefy.dialog.confirm({
          title: i18n.giftConfirmTitle[this.iso],
          message,
          confirmText: i18n.giftConfirmOk[this.iso],
          cancelText: i18n.giftConfirmCancel[this.iso],
          type: "is-warning",
          hasIcon: true,
          onConfirm: () => resolve(true),
          onCancel: () => resolve(false),
        });
      });
    },
    parseDateTimestamp(value) {
      moment.locale(this.iso);
      return value ? moment(value).format("MMMM D, YYYY") : "";
    },
    formatCurrency(value, tipoDescuento) {
      const amount = value || 0;
      if (tipoDescuento === "percentage") {
        return `${amount}%`;
      }
      return new Intl.NumberFormat("en-US", {
        style: "currency",
        currency: "USD",
      }).format(amount);
    },
    splitPhoneNumber(raw) {
      const cleaned = (raw || "").toString().trim();
      if (!cleaned) return { lada: null, phone: null };

      const digits = cleaned.replace(/[^0-9]/g, "");
      if (!digits) return { lada: null, phone: null };

      if (!cleaned.startsWith("+")) {
        return { lada: null, phone: digits };
      }

      const ladas = (this.uniqueLadas || [])
        .map((p) => (p?.Lada !== undefined && p?.Lada !== null ? String(p.Lada) : ""))
        .filter(Boolean)
        .sort((a, b) => b.length - a.length);
      const match = ladas.find((lada) => digits.startsWith(lada));

      if (match) {
        return { lada: match, phone: digits.slice(match.length) };
      }

      const fallbackLada = digits.slice(0, Math.min(3, digits.length));
      return {
        lada: fallbackLada || null,
        phone: digits.slice(fallbackLada.length) || null,
      };
    },
    registerMember(row) {
      const { lada, phone } = this.splitPhoneNumber(row?.Telefono);
      this.$router.push({
        name: "NewMemberCap",
        query: {
          name: row.Nombre,
          lastname: row.Apellido,
          email: row.Email,
          id_presocio: row._id || row.Id,
          lada,
          phone,
          iso: row?.Idioma || 'EN',
          nationality: row?.Nacionalidad || null,
          TipoMembresia: 'CFF54C73-B483-4F12-9599-5AC5E4FAF003',
          EstadoContrato: 1,
          contractNumber: 'HTS-',
          vipWeeks: 99,
          smartWeeks: 99,
          lastMinuteWeeks: 99,
          ...(row?.Autocompletado ? row.Autocompletado : {}),
        },
      });
    },
    goToProfile(row) {
      if (row.MemberId) {
        this.$router.push(`/profile-member?id=${row.MemberId}`);
      }
    },
    validatePhoneInput() {
      if (this.prospecto.Telefono) {
        // Remove any character that is not a number
        this.prospecto.Telefono = this.prospecto.Telefono.replace(
          /[^0-9]/g,
          "",
        );
      }
    },
    validatePhoneKeypress(event) {
      // Allow only numbers (0-9)
      const char = String.fromCharCode(event.keyCode || event.which);
      if (!/[0-9]/.test(char)) {
        event.preventDefault();
      }
    },
    async openModalCrearReunion() {
      this.reunion = { Hora: null, Enlace: null };
      this.errorReunion = false;
      this.ModalCrearReunion = true;
      // Se listan los horarios ya creados para mostrarlos como referencia y
      // poder rechazar duplicados antes de mandar el POST.
      await this.listReuniones();
    },
    // El timepicker devuelve un Date; en BD la hora vive como "HH:mm" (24 h).
    horaToString(value) {
      if (!(value instanceof Date) || isNaN(value.getTime())) return null;
      const h = String(value.getHours()).padStart(2, "0");
      const m = String(value.getMinutes()).padStart(2, "0");
      return `${h}:${m}`;
    },
    // Minutos desde medianoche, para ordenar horarios arbitrarios.
    horaToMinutes(hora) {
      if (!hora) return Number.MAX_SAFE_INTEGER;
      const [h, m] = String(hora).split(":").map((n) => parseInt(n, 10));
      if (isNaN(h)) return Number.MAX_SAFE_INTEGER;
      return h * 60 + (isNaN(m) ? 0 : m);
    },
    // "18:30" -> "6:30 PM" para los selectores; la tabla y el Excel se quedan en 24 h.
    formatHora(hora) {
      if (!hora) return "";
      const [h, m] = String(hora).split(":").map((n) => parseInt(n, 10));
      if (isNaN(h)) return hora;
      const sufijo = h >= 12 ? "PM" : "AM";
      const h12 = h % 12 === 0 ? 12 : h % 12;
      return `${h12}:${String(isNaN(m) ? 0 : m).padStart(2, "0")} ${sufijo}`;
    },
    async openModalEliminarReunion() {
      this.selectedReunionId = null;
      this.errorReunion = false;
      await this.listReuniones();
      this.ModalEliminarReunion = true;
    },
    async listReuniones() {
      try {
        this.loadingReuniones = true;
        const { data } = await axios.get(
          `${API_URL}/catcher/meetings?clubId=${this.club?.Id || ""}`
        );
        this.reunionesList = Array.isArray(data) ? data : [];
      } catch (err) {
        console.error("Error loading meetings:", err);
        this.$buefy.toast.open({
          message: i18n.errorLoadingMeetings[this.iso],
          type: "is-danger",
        });
      } finally {
        this.loadingReuniones = false;
      }
    },
    async crearReunion() {
      try {
        const hora = this.horaToString(this.reunion.Hora);
        if (!hora || !this.reunion.Enlace) {
          this.errorReunion = i18n.applyId__fail[this.iso];
          return;
        }
        // El backend no valida duplicados: dos reuniones con la misma hora
        // aparecerían repetidas en el selector del capturador.
        if (this.reunionesList.some((r) => r.Hora === hora)) {
          this.errorReunion = i18n.meetingTimeExists[this.iso];
          return;
        }
        let url;
        try {
          url = new URL(this.reunion.Enlace);
        } catch (_) {
          this.errorReunion = i18n.invalidUrl[this.iso];
          return;
        }
        if (url.protocol !== "https:") {
          this.errorReunion = i18n.invalidUrl[this.iso];
          return;
        }
        this.loadingCrearReunion = true;
        await axios.post(`${API_URL}/catcher/meeting`, {
          Hora: hora,
          Enlace: this.reunion.Enlace,
          ClubId: this.club?.Id || null,
        });
        this.loadingCrearReunion = false;
        this.ModalCrearReunion = false;
        this.$buefy.toast.open({
          message: i18n.meetingCreated[this.iso],
          type: "is-success",
        });
        // Refresco para que el horario nuevo quede disponible al agendar sin
        // tener que recargar la pantalla.
        await this.listReuniones();
      } catch (err) {
        this.loadingCrearReunion = false;
        console.error("Error creating meeting:", err);
        const msg = err?.response?.data?.error || err?.response?.data?.message;
        this.errorReunion = msg || i18n.errorCreatingMeeting[this.iso];
      }
    },
    async eliminarReunion() {
      try {
        if (!this.selectedReunionId) {
          this.errorReunion = i18n.applyId__fail[this.iso];
          return;
        }
        this.loadingEliminarReunion = true;
        await axios.delete(`${API_URL}/catcher/meeting/${this.selectedReunionId}`);
        this.loadingEliminarReunion = false;
        this.ModalEliminarReunion = false;
        this.$buefy.toast.open({
          message: i18n.meetingDeleted[this.iso],
          type: "is-success",
        });
        await this.listReuniones();
      } catch (err) {
        this.loadingEliminarReunion = false;
        console.error("Error deleting meeting:", err);
        const msg = err?.response?.data?.error || err?.response?.data?.message;
        this.errorReunion = msg || i18n.errorDeletingMeeting[this.iso];
      }
    },
    loadHubspotStages() {
      // Stages del pipeline "Online Sales – MVP" (840640860) en su orden de HubSpot.
      // Deben coincidir textualmente con el stageName que el webhook deal-stage-update
      // guarda en Prospecto.EstadoHubSpot; si se renombra un stage en HubSpot, el
      // backend corre scripts/sync-hubspot-stages.js y hay que reflejarlo también aquí
      // y en i18n.hubspotStagesTranslation.
      // Ojo: "Payment Completed – Closed Won" lleva guion largo (–), no guion normal.
      this.hubspotStages = [
        'New Lead',
        'Contacted',
        'Presentation Scheduled',
        'Presentation No-Show / Missed',
        'Show Complete No Sale',
        'Show No Compl/Walkout',
        'Sale & Gift',
        'Sale No Gift',
        'Contract Sent',
        'Contract Signed',
        'Payment Completed – Closed Won',
        'Closed Lost'
      ];
    },
    async loadCurrentUserData() {
      try {
        const userId = localStorage.getItem("userId");
        if (!userId) return;

        const { data } = await axios.get(`${API_URL}/system/users/${userId}`);
        this.currentUserData = data?.data || data;

        if (this.isCurrentUserVendor) {
          this.prospecto.Vendedor = this.currentUserData._id;
        }
      } catch (err) {
        console.error("Error loading current user data:", err);
        this.currentUserData = null;
      }
    },
    async loadSystemRoles() {
      try {
        const { data } = await axios.post(`${API_URL}/system/list-roles`, {
          Activo: true,
        });
        this.systemRoles = data?.roles || [];
      } catch (err) {
        console.error("Error loading roles:", err);
        this.systemRoles = [];
      }
    },
    async loadAvailableVendors() {
      try {
        this.loadingVendedores = true;
        const { data } = await axios.get(
          `${API_URL}/system/users?clubId=${this.club?.Id || ''}&active=true`
        );
        const allUsers = Array.isArray(data) ? data : (data?.data || []);
        this.allUsers = allUsers;
        this.availableVendors = allUsers.filter(u => u.Rol === this.vendorRoleId);
        // Directorio completo: la tabla resuelve el Vendedor aunque el usuario
        // ya no tenga el rol de vendor.
        this.usersById = allUsers.reduce((acc, u) => {
          if (u && u._id) acc[u._id] = u;
          return acc;
        }, {});
        this.usersByUsuario = allUsers.reduce((acc, u) => {
          if (u && u.Usuario) acc[u.Usuario] = u;
          return acc;
        }, {});
      } catch (err) {
        console.error("Error loading vendors:", err);
        this.availableVendors = [];
      } finally {
        this.loadingVendedores = false;
      }
    },
    getUserName(user) {
      if (!user) return "";
      const nombre = `${user.Nombre || ""} ${user.Apellido || ""}`.trim();
      return nombre || user.Usuario || "";
    },
    getUserNameById(id) {
      if (!id) return "";
      // El campo puede venir poblado (objeto) o solo como id.
      const user = typeof id === "object" ? id : this.usersById[id];
      return this.getUserName(user);
    },
    // Los puestos del manifiesto guardan el Usuario, no el _id.
    getStaffName(usuario) {
      if (!usuario) return "";
      if (typeof usuario === "object") return this.getUserName(usuario);
      const user = this.usersByUsuario[usuario];
      // Si el usuario ya no está en el catálogo (baja, cambio de club) se
      // muestra su Usuario tal cual: sigue siendo legible.
      return user ? this.getUserName(user) : usuario;
    },
    getVendorName(row) {
      // Los leads de marketing de SSP no tienen vendor: se muestra su fuente
      // ("Marketing Meta Ads – OBE"), que llega en el mismo campo que el vendor.
      return this.getUserNameById(row?.Vendedor) || (this.isSsp(row) && row?.Calificacion?.VendorSource) || "";
    },
    // ---- Leads de Sales Systems Pros (Origen "Marketing SSP") ----
    puedeGenerarLinkPago(row) {
      return row.Estado !== "pendingToSign" && row.Estado !== "won" && this.$checkPermission("cap-guests-payment-link");
    },
    // Sin ninguna acción disponible (p. ej. el rol Vendedor, solo lectura) no se muestra el menú
    tieneMenuAcciones(row) {
      return (
        ["cap-guests-edit", "cap-guests-manifest", "cap-guests-register-code", "cap-guests-complete-registration"].some(
          (permiso) => this.$checkPermission(permiso),
        ) || this.puedeGenerarLinkPago(row)
      );
    },
    isSsp(row) {
      return row?.Origen === "Marketing SSP";
    },
    tieneRevision(row) {
      return Array.isArray(row?.Revision) && row.Revision.length > 0;
    },
    tieneMarca(row, marca) {
      return Array.isArray(row?.Revision) && row.Revision.includes(marca);
    },
    revisionTooltip(row) {
      const marcas = (row?.Revision || []).map((marca) => this.ssp.reviewShort[marca] || marca);
      return `${this.ssp.needsReview}: ${marcas.join(", ")}`;
    },
    citaEstado(row) {
      return String(row?.Cita?.Estado || "").toLowerCase() || null;
    },
    // Invalid (GHL) se trata como una cancelación: libera el asiento
    citaCancelada(row) {
      return ["cancelled", "invalid"].includes(this.citaEstado(row));
    },
    // Rating del manifiesto para la tabla: "Closed lost" manda sobre el rating, como en HubSpot
    ratingFila(row) {
      const m = row?.Manifiesto;
      if (!m) return null;
      if (m.Perdido) return { texto: i18n.markAsLost[this.iso], tipo: "is-dark" };
      if (!m.Rating) return null;
      const tipos = { noShow: "is-warning", walkout: "is-danger is-light", showFail: "is-info is-light", showWin: "is-success" };
      return { texto: this.ratingLabel(m.Rating), tipo: tipos[m.Rating] || "is-light" };
    },
    detalleRating(row) {
      const m = row?.Manifiesto || {};
      const partes = [];
      if (m.Perdido) partes.push(`${i18n.rating[this.iso]}: ${this.ratingLabel(m.Rating) || "—"}`);
      if (m.Rating === "showWin") partes.push(`${i18n.giftType[this.iso]}: ${m.GiftType ? this.giftTypeLabel(m.GiftType) : i18n.noGift[this.iso]}`);
      if (m.Clasificacion) partes.push(`${i18n.classification[this.iso]}: ${m.Clasificacion}`);
      if (m.Perdido && m.MotivoPerdida) partes.push(m.MotivoPerdida);
      return partes.join(" · ") || i18n.rating[this.iso];
    },
    // Estado de la cita para la tabla. Un lead de SSP trae el de GHL; un in house
    // lo deducimos de su etapa de HubSpot, con los mismos nombres.
    estadoCitaFila(row) {
      const deGhl = this.isSsp(row) ? this.citaEstado(row) : null;
      const rating = row?.Manifiesto?.Rating;
      let estado = null;
      // Cancelada o inválida en GHL manda; si no, el manifiesto (ya pasó la presentación); si no, la cita
      if (["cancelled", "invalid"].includes(deGhl)) estado = deGhl;
      else if (rating) estado = rating === "noShow" ? "noshow" : "showed";
      else estado = deGhl;
      if (!estado) {
        const porEtapa = {
          "Presentation Scheduled": "confirmed",
          "Presentation No-Show / Missed": "noshow",
          "Show Complete No Sale": "showed",
          "Show No Compl/Walkout": "showed",
          "Sale & Gift": "showed",
          "Sale No Gift": "showed",
          "Contract Sent": "showed",
          "Contract Signed": "showed",
          "Payment Completed – Closed Won": "showed",
          "Presentation Attended": "showed",
          "Payment Completed": "showed",
        };
        estado = porEtapa[row?.EstadoHubSpot] || null;
      }
      if (!estado) return null;
      return { texto: this.ssp.appointmentStatus[estado] || estado, tipo: this.citaEstadoTipo({ Cita: { Estado: estado } }) };
    },
    // La presentación ya pasó: una hora después del inicio de la sesión, en hora de Cancún
    presentacionPaso(row) {
      if (!row?.MeetingDate) return false;
      const dia = moment.utc(row.MeetingDate).format("YYYY-MM-DD");
      // Sin sesión asignada no hay hora: cuenta como pasada al terminar el día
      const fin = row?.MeetingId?.Hora
        ? moment.tz(`${dia} ${row.MeetingId.Hora}`, "YYYY-MM-DD HH:mm", "America/Cancun").add(1, "hour")
        : moment.tz(dia, "YYYY-MM-DD", "America/Cancun").endOf("day");
      return fin.isValid() && moment().isAfter(fin);
    },
    manifiestoPendiente(row) {
      const m = row?.Manifiesto;
      if (m?.Rating || m?.Perdido) return false;
      return this.presentacionPaso(row) && !this.citaCancelada(row);
    },
    // Lo que le falta a un manifiesto capturado (un No Show no se califica)
    faltantesManifiesto(row) {
      const m = row?.Manifiesto;
      if (!m?.Rating || m.Perdido || m.Rating === "noShow") return [];
      const faltan = [];
      if (!m.Clasificacion) faltan.push(i18n.classification[this.iso]);
      return faltan;
    },
    etapaHubspotTooltip(row) {
      if (!row?.EstadoHubSpot) return "";
      return `${i18n.stage[this.iso]}: ${this.getStageTranslation(row.EstadoHubSpot, this.iso)}`;
    },
    citaEstadoLabel(row) {
      const estado = this.citaEstado(row);
      return this.ssp.appointmentStatus[estado] || row?.Cita?.Estado || "";
    },
    citaEstadoTipo(row) {
      const tipos = { confirmed: "is-success", cancelled: "is-danger", invalid: "is-danger", noshow: "is-warning", showed: "is-info" };
      return tipos[this.citaEstado(row)] || "is-light";
    },
    // Las sesiones se definen en hora de Cancún (UTC-5 fijo, igual que HubSpot),
    // así que la cita se muestra en esa zona sin importar la del navegador
    formatCancun(ms) {
      if (ms === null || ms === undefined || ms === "") return "";
      const fecha = moment.tz(Number(ms), "America/Cancun");
      if (!fecha.isValid()) return "";
      return fecha.format(this.iso === "es" ? "DD/MM/YYYY h:mm A" : "MM/DD/YYYY h:mm A");
    },
    formatValorCampo(valor) {
      if (valor === null || valor === undefined || valor === "") return "—";
      if (Array.isArray(valor)) return valor.length ? valor.join(" | ") : "—";
      if (typeof valor === "object") return JSON.stringify(valor);
      return String(valor);
    },
    sortByVendor(a, b, isAsc) {
      const na = this.getVendorName(a).toLowerCase();
      const nb = this.getVendorName(b).toLowerCase();
      // Los invitados sin vendor siempre van al final.
      if (!na && !nb) return 0;
      if (!na) return 1;
      if (!nb) return -1;
      return isAsc ? na.localeCompare(nb) : nb.localeCompare(na);
    },
    async loadOccupancy() {
      try {
        const { data } = await axios.post(`${API_URL}/prospectos/list?limit=1000&page=1`, {
          ClubId: this.club?.Id || null,
        });

        this.guestsByDateHour = {};

        const guests = Array.isArray(data) ? data : (data?.docs || data?.prospectos || []);
        guests.forEach((guest) => {
          if (!guest.MeetingId || !guest.MeetingDate) return;

          // MeetingDate es la marca del día de México: se lee en UTC.
          // MeetingId puede venir poblado (objeto), así que se usa su _id.
          const dateStr = moment.utc(guest.MeetingDate).format("YYYY-MM-DD");
          const meetingId = guest.MeetingId._id || guest.MeetingId;
          const key = `${dateStr}_${meetingId}`;

          if (!this.guestsByDateHour[key]) {
            this.guestsByDateHour[key] = 0;
          }
          this.guestsByDateHour[key]++;
        });
      } catch (err) {
        console.error("Error loading occupancy:", err);
      }
    },
    getHourOccupancy(date, meetingId) {
      if (!date) return 0;
      const dateStr = this.pickerDateKey(date);
      const key = `${dateStr}_${meetingId}`;
      return this.guestsByDateHour[key] || 0;
    },
    getDayOccupancy(date) {
      if (!date) return 0;
      const dateStr = this.pickerDateKey(date);
      let total = 0;
      this.reunionesList.forEach((meeting) => {
        const key = `${dateStr}_${meeting._id}`;
        total += this.guestsByDateHour[key] || 0;
      });
      return total;
    },
  },
};
</script>

<style scoped>
.filter-compact {
  margin: 0 !important;
}

/* Acciones de la tabla de guests: siempre en una sola línea */
.guest-actions {
  display: inline-flex;
  align-items: center;
  gap: 0.35rem;
  white-space: nowrap;
}

.guest-actions-hint {
  font-size: 0.75rem;
  color: #7a7a7a;
  white-space: normal;
  max-width: 14rem;
}

.filter-compact .column {
  padding: 0.25rem !important;
}

.filter-compact .field {
  margin-bottom: 0 !important;
}

.filter-compact .field-label {
  font-size: 0.875rem;
  font-weight: 600;
}

.filter-compact .input,
.filter-compact .select select {
  font-size: 1rem;
}

/* Buefy no trae naranja: se replica el estilo "is-light" de Bulma para que el
   botón de detalle no se confunda con el amarillo de editar. */
.button.is-orange-light {
  background-color: #ffeedc;
  color: #b03e00;
  border-color: transparent;
}

.button.is-orange-light:hover,
.button.is-orange-light:focus {
  background-color: #ffdfc0;
  color: #8c3100;
}

.detail-title {
  font-weight: 700;
  font-size: 1rem;
  color: #363636;
  border-bottom: 1px solid #dbdbdb;
  padding-bottom: 0.35rem;
  margin: 1.25rem 0 0.75rem;
}

.detail-title:first-child {
  margin-top: 0;
}

.detail-grid .column {
  padding: 0.4rem 0.75rem;
}

.detail-label {
  font-size: 0.72rem;
  text-transform: uppercase;
  letter-spacing: 0.03em;
  color: #7a7a7a;
  font-weight: 600;
}

.detail-value {
  font-size: 0.95rem;
  color: #363636;
  word-break: break-word;
  /* Los campos vacíos conservan su alto para no desalinear la cuadrícula. */
  min-height: 1.4rem;
}
</style>
